/**
 * Theme-Overlay am Angle-3D-Konfigurator.
 * 1) Partner-Optionsgruppen (Abrex / Abelcarbon / CSTMPLSTR): classList.add.
 *    Partner: Sibling-<a> (Logo + Preis + Pfeil), kein Wrap der Option.
 * 2) Wunschfarbe-Farbkreis: Sibling-Panel, färbt Lackset-Meshes, schreibt
 *    URL-Param + Parent-Line-Item-Property. Kein Wrap, kein ATC-Click-Intercept.
 * 3) REEL: dritter Viewer-Button + Overlay. Kein Wrap, kein ATC-Intercept,
 *    kein /cart/add.js, kein Stripe, keine Theme-Mails. tdaState roh lassen.
 * Bei App-Updates prüfen:
 * .tda-customizer-customization-option-title, .tda-customizer-customization-option,
 * .tda-customizer-color-palette-customization-option-value,
 * [tda-variant-option-value], .swiper-option-value-info,
 * .swiper-selected-option-value-detail, tda-model-viewer, cart/add.js-Body,
 * .tda-app-section-model-viewer-sticky-container.
 */
(function () {
  if (window.AS51ProductHandle && window.AS51ProductHandle !== '3d-konfigurator') return;
  if (window.AS51PartnerInit) return;
  window.AS51PartnerInit = true;

  var PARTNERS = [
    // Abrex lackiert alle Tanks + Seitendeckel → Header auch am Lackset-/Farbe-Schritt.
    { re: /abrex|lackset|^\s*farbe\s*$/i, cls: 'wh-abrex-option' },
    {
      re: /lenkpolster|lenkerpolster|cstmplstr|custom\s*polster/i,
      cls: 'wh-cstmplstr-option'
    },
    {
      re: /abelcarbon|abel\s*carbon|carbon[\s\-]*seitendeckel|seitendeckel[\s\-]*carbon/i,
      cls: 'wh-abelcarbon-option'
    }
  ];
  var SHOP_CLS = 'wh-abelcarbon-shop';
  var HOST_CLS = 'has-abelcarbon-shop';
  var DEFAULT_HREF =
    'https://abelcarbon.de/products/carbon-seitendeckel-export-fur-simson-s50-s51-mit-forged-und-flakes?utm_source=area-s51&utm_medium=referral&utm_campaign=s51-konfigurator';

  var observed = null;
  var injecting = false;

  function partnerClass(el) {
    var text = (el && el.textContent) || '';
    for (var i = 0; i < PARTNERS.length; i++) {
      if (PARTNERS[i].re.test(text)) return PARTNERS[i].cls;
    }
    return null;
  }

  function shopCfg(partner) {
    if (partner === 'abrex') {
      var abrex = window.AS51Abrex || {};
      return {
        href: abrex.href || 'https://www.instagram.com/abrex_gmbh/',
        logo: abrex.logo || '',
        label: abrex.label || '',
        name: 'Abrex',
        description: 'Abrex Premiumlack',
        id: 'abrex',
        domain: 'instagram.com'
      };
    }
    if (partner === 'cstmplstr') {
      var cstm = window.AS51Cstmplstr || {};
      return {
        href:
          cstm.href ||
          'https://custompolster.de/?utm_source=area-s51&utm_medium=referral&utm_campaign=s51-konfigurator',
        logo: cstm.logo || '',
        label: cstm.label || 'ab 33 EUR',
        name: 'CSTMPLSTR',
        description: 'CSTMPLSTR Lenkpolster',
        id: 'cstmplstr',
        domain: 'custompolster.de'
      };
    }
    var c = window.AS51Abelcarbon || {};
    return {
      href: c.href || DEFAULT_HREF,
      logo: c.logo || '',
      label: c.label || 'ab 299 €',
      name: 'Abelcarbon',
      description: 'Abelcarbon Seitendeckel',
      id: 'abelcarbon',
      domain: 'abelcarbon.de'
    };
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function logoUrl(partner) {
    var cfg = shopCfg(partner);
    var logo = cfg.logo;
    if (logo) return logo;
    try {
      var wrap = document.querySelector('.tda-customizer-wrapper');
      if (!wrap) return '';
      var raw = getComputedStyle(wrap).getPropertyValue('--wh-' + cfg.id + '-logo');
      var m = raw && raw.match(/url\(["']?([^"')]+)["']?\)/);
      return m ? m[1] : '';
    } catch (e) {
      return '';
    }
  }

  // GA4 über das gtag der Google-&-YouTube-App (seit 2026-10-06; vorher Analyzely).
  function gaEvent() {
    if (typeof window.gtag === 'function') {
      window.gtag.apply(null, arguments);
    }
  }

  function trackClick(partner) {
    try {
      var cfg = shopCfg(partner);
      var href = cfg.href;
      // Allgemeines outbound_click sendet werkhalle-outbound.js; hier nur das
      // partnerspezifische Event.
      gaEvent('event', cfg.id + '_outbound', {
        event_category: 'outbound',
        event_label: cfg.id,
        link_url: href,
        link_domain: cfg.domain,
        outbound: true,
        location: 's51-konfigurator',
        transport_type: 'beacon'
      });
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        window.Shopify.analytics.publish(cfg.id + '_outbound', {
          destination: cfg.domain,
          location: 's51-konfigurator'
        });
      }
    } catch (e) {
      /* fail-open */
    }
  }

  function bindShop(a, partner) {
    if (a.getAttribute('data-wh-bound')) return;
    a.setAttribute('data-wh-bound', '1');
    a.addEventListener('click', function (ev) {
      ev.stopPropagation();
      trackClick(partner);
    });
    a.addEventListener('pointerdown', function (ev) {
      ev.stopPropagation();
    });
  }

  function buildShop(extraClass, partner) {
    var cfg = shopCfg(partner);
    var a = document.createElement('a');
    a.className = extraClass ? SHOP_CLS + ' ' + extraClass : SHOP_CLS;
    a.href = cfg.href;
    a.target = '_blank';
    a.rel = 'nofollow noopener';
    a.setAttribute('referrerpolicy', 'origin');
    a.setAttribute(
      'aria-label',
      cfg.description + (cfg.label ? ', ' + cfg.label : '') + ' (öffnet neuen Tab)'
    );
    var logo = logoUrl(partner);
    var html = '';
    if (logo) {
      html +=
        '<img class="wh-abelcarbon-shop__logo" src="' +
        escapeHtml(logo) +
        '" alt="' + cfg.name + '" width="110" height="32" decoding="async">';
    }
    if (cfg.label) {
      html += '<span class="wh-abelcarbon-shop__tag">' + escapeHtml(cfg.label) + '</span>';
    }
    html +=
      '<svg class="wh-abelcarbon-shop__arrow" viewBox="0 0 12 12" aria-hidden="true" focusable="false">' +
      '<path fill="currentColor" d="M3 2h7v7H8.5V4.56L2.78 10.28 1.72 9.22 7.44 3.5H3V2z"/></svg>';
    a.innerHTML = html;
    bindShop(a, partner);
    return a;
  }

  function hostTitle(el) {
    if (!el) return '';
    var bits = [];
    var title = el.querySelector ? el.querySelector('.tda-customizer-customization-option-title') : null;
    if (title) bits.push(title.textContent);
    var strong = el.querySelector ? el.querySelector('strong') : null;
    if (strong) bits.push(strong.textContent);
    return bits.join(' ');
  }

  function isSeitendeckelHost(el) {
    return /seitendeckel/i.test(hostTitle(el));
  }

  function isShopHost(el) {
    var t = hostTitle(el);
    return /seitendeckel/i.test(t) || /carbon\s*style/i.test(t) || /abel\s*carbon/i.test(t);
  }

  function isShown(el) {
    if (!el) return false;
    try {
      var cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') return false;
      var box = el.getBoundingClientRect();
      if (box.width === 0 && box.height === 0) return false;
    } catch (e) {
      /* ignore */
    }
    return true;
  }

  function buildHead() {
    var head = document.createElement('div');
    head.className = 'wh-abelcarbon-head';
    var kicker = document.createElement('span');
    kicker.className = 'wh-abelcarbon-head__kicker';
    kicker.textContent = 'Carbon';
    head.appendChild(kicker);
    head.appendChild(buildShop());
    return head;
  }

  function removeShop(host) {
    if (!host) return;
    var head = host.querySelector('.wh-abelcarbon-head');
    var shop = host.querySelector('.' + SHOP_CLS);
    injecting = true;
    if (head && head.parentNode === host) head.parentNode.removeChild(head);
    else if (shop && shop.parentNode === host) shop.parentNode.removeChild(shop);
    injecting = false;
    host.classList.remove(HOST_CLS);
  }

  function injectCard(option) {
    if (!option) return;
    if (option.querySelector('.wh-abelcarbon-head')) {
      option.classList.add(HOST_CLS);
      return;
    }
    injecting = true;
    option.insertBefore(buildHead(), option.firstChild);
    option.classList.add(HOST_CLS);
    injecting = false;
  }

  function pickCardHost(cards) {
    var visible = [];
    var i;
    for (i = 0; i < cards.length; i++) {
      if (!isShown(cards[i])) continue;
      if (!isShopHost(cards[i])) continue;
      visible.push(cards[i]);
    }
    for (i = 0; i < visible.length; i++) {
      if (isSeitendeckelHost(visible[i])) return visible[i];
    }
    return visible[0] || null;
  }

  function injectCards() {
    var cards = document.querySelectorAll(
      '.tda-customizer-customization-option.wh-abelcarbon-option'
    );
    var eligible = [];
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].closest('.swiper-summary-container-customization-option')) continue;
      if (cards[i].classList.contains('swiper-slide')) continue;
      if (cards[i].closest('.swiper-slide')) continue;
      eligible.push(cards[i]);
    }
    var host = pickCardHost(eligible);
    for (var j = 0; j < eligible.length; j++) {
      if (eligible[j] === host) injectCard(eligible[j]);
      else removeShop(eligible[j]);
    }
  }

  function buildWizardLink() {
    var a = document.createElement('a');
    a.className = SHOP_CLS + ' ' + SHOP_CLS + '--wizard';
    a.href = shopCfg().href;
    a.target = '_blank';
    a.rel = 'nofollow noopener';
    a.setAttribute('referrerpolicy', 'origin');
    a.setAttribute(
      'aria-label',
      'Abelcarbon Seitendeckel, ' + shopCfg().label + ' (öffnet neuen Tab)'
    );
    bindShop(a);
    return a;
  }

  function injectWizard() {
    var wrap = document.querySelector('.tda-customizer-wrapper');
    if (!wrap) return;
    var container = wrap.querySelector('.tda-customizer-customization-options-container');
    if (!container) return;
    var onCarbon = container.querySelector(
      '.swiper-slide.wh-abelcarbon-option.swiper-slide-active'
    );
    var existing = container.querySelector('.' + SHOP_CLS + '--wizard');
    if (!onCarbon) {
      if (existing && existing.parentNode) {
        injecting = true;
        existing.parentNode.removeChild(existing);
        injecting = false;
      }
      container.classList.remove(HOST_CLS);
      return;
    }
    if (existing) {
      container.classList.add(HOST_CLS);
      return;
    }
    injecting = true;
    container.insertBefore(buildWizardLink(), container.firstChild);
    container.classList.add(HOST_CLS);
    injecting = false;
  }

  // Angle-Beschreibung des Schritts als Text unter dem Abrex-Logo spiegeln
  // (Original bleibt im DOM, wird per CSS ausgeblendet). Nur bei Änderung
  // schreiben, damit der MutationObserver nicht in eine Schleife läuft.
  function syncAbrexDesc(parent, after, source, extraClass) {
    var text = source ? (source.textContent || '').replace(/\s+/g, ' ').trim() : '';
    var el = parent.querySelector('.wh-abrex-desc');
    if (!text) {
      if (el) el.remove();
      return;
    }
    if (!el) {
      el = document.createElement('p');
      el.className = extraClass ? 'wh-abrex-desc ' + extraClass : 'wh-abrex-desc';
      if (after && after.nextSibling) parent.insertBefore(el, after.nextSibling);
      else parent.appendChild(el);
    }
    if (el.textContent !== text) el.textContent = text;
  }

  function injectAbrex() {
    var cards = document.querySelectorAll('.tda-customizer-customization-option.wh-abrex-option');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.closest('.swiper-summary-container-customization-option, .swiper-slide')) continue;
      var head = card.querySelector('.wh-abrex-head');
      if (!head) {
        head = document.createElement('div');
        head.className = 'wh-abelcarbon-head wh-abrex-head';
        head.appendChild(buildShop('wh-abrex-shop', 'abrex'));
        card.insertBefore(head, card.firstChild);
        card.classList.add('has-abrex-shop');
      }
      syncAbrexDesc(
        head,
        head.querySelector('.wh-abrex-shop'),
        card.querySelector(':scope > .tda-customizer-customization-option-description')
      );
    }

    var container = document.querySelector(
      '.tda-customizer-wrapper .tda-customizer-customization-options-container'
    );
    if (!container) return;
    var active = container.querySelector('.swiper-slide.wh-abrex-option.swiper-slide-active');
    var existing = container.querySelector('.wh-abrex-shop--wizard');
    var wizardDesc = container.querySelector(':scope > .wh-abrex-desc');
    if (!active) {
      if (existing) existing.remove();
      if (wizardDesc) wizardDesc.remove();
      container.classList.remove('has-abrex-shop');
      return;
    }
    if (!existing) {
      existing = buildShop('wh-abrex-shop wh-abrex-shop--wizard', 'abrex');
      container.insertBefore(existing, container.firstChild);
    }
    container.classList.add('has-abrex-shop');
    syncAbrexDesc(
      container,
      existing,
      container.querySelector(':scope > .swiper-summary-customization-option-description'),
      'wh-abrex-desc--wizard'
    );
  }

  function injectCstmplstr() {
    var cards = document.querySelectorAll('.tda-customizer-customization-option.wh-cstmplstr-option');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.closest('.swiper-summary-container-customization-option, .swiper-slide')) continue;
      if (card.querySelector('.wh-cstmplstr-head')) continue;
      var head = document.createElement('div');
      head.className = 'wh-abelcarbon-head wh-cstmplstr-head';
      var kicker = document.createElement('span');
      kicker.className = 'wh-abelcarbon-head__kicker';
      kicker.textContent = 'Polster';
      head.appendChild(kicker);
      head.appendChild(buildShop('wh-cstmplstr-shop', 'cstmplstr'));
      card.insertBefore(head, card.firstChild);
      card.classList.add('has-cstmplstr-shop');
    }

    var container = document.querySelector(
      '.tda-customizer-wrapper .tda-customizer-customization-options-container'
    );
    if (!container) return;
    var active = container.querySelector('.swiper-slide.wh-cstmplstr-option.swiper-slide-active');
    var existing = container.querySelector('.wh-cstmplstr-shop--wizard');
    if (!active) {
      if (existing) existing.remove();
      container.classList.remove('has-cstmplstr-shop');
      return;
    }
    if (!existing) {
      container.insertBefore(
        buildShop('wh-cstmplstr-shop wh-cstmplstr-shop--wizard', 'cstmplstr'),
        container.firstChild
      );
    }
    container.classList.add('has-cstmplstr-shop');
  }

  function mark() {
    if (injecting) return;
    var titles = document.querySelectorAll('.tda-customizer-customization-option-title');
    for (var i = 0; i < titles.length; i++) {
      var cls = partnerClass(titles[i]);
      if (!cls) continue;
      var option = titles[i].closest('.tda-customizer-customization-option');
      if (option) option.classList.add(cls);
      var titleSlide = titles[i].closest('.swiper-slide');
      if (titleSlide && !titleSlide.closest('.option-value-swiper-container')) {
        titleSlide.classList.add(cls);
      }
    }

    // Wizard-Schritt-Titel sitzen in #swiper-container-{modelId} > .swiper-slide > strong
    // — nicht in .swiper-summary-container-customization-option (End-Zusammenfassung).
    var strongs = document.querySelectorAll('.tda-customizer-wrapper .swiper-slide strong');
    for (var j = 0; j < strongs.length; j++) {
      if (strongs[j].closest('.option-value-swiper-container')) continue;
      var slideCls = partnerClass(strongs[j]);
      if (!slideCls) continue;
      var slide = strongs[j].closest('.swiper-slide');
      if (slide) slide.classList.add(slideCls);
    }

    var lines = document.querySelectorAll('.swiper-summary-line-co-title');
    for (var k = 0; k < lines.length; k++) {
      var lineCls = partnerClass(lines[k]);
      if (lineCls) lines[k].classList.add(lineCls);
    }

    injectCards();
    injectWizard();
    injectAbrex();
    injectCstmplstr();
  }

  function attach() {
    var wrap = document.querySelector('.tda-customizer-wrapper');
    if (!wrap) return false;
    if (wrap !== observed) {
      observed = wrap;
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var record = records[i];
          if (record.type === 'childList' ||
              /\bswiper-slide-active\b/.test(record.oldValue || '') !==
                record.target.classList.contains('swiper-slide-active')) {
            mark();
            return;
          }
        }
      }).observe(wrap, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeOldValue: true,
        attributeFilter: ['class']
      });
    }
    mark();
    return true;
  }

  window.addEventListener('Angle3DCustomizerLoaded', attach);

  if (attach()) return;

  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    if (attach() || tries >= 50) clearInterval(timer);
  }, 300);
})();

/**
 * Wunschfarbe: Farbkreis unter Lackset, sobald der Swatch aktiv ist.
 * Recolor trifft die Lackset-Meshes aus dem Angle-Modell
 * (Owner 2026-08-25: mesh_0_176nr003, mesh_0_176nr003_59, mesh_0_176nr007_1).
 * Persistenz: ?wunschfarbe=RRGGBB (landet in 3D Customizer URL) und
 * Line-Item-Property Wunschfarbe am Parent — fail-open am cart/add.js.
 */
(function () {
  if (
    window.AS51ProductHandle &&
    window.AS51ProductHandle !== '3d-konfigurator' &&
    window.AS51ProductHandle !== '3d-konfigurator-schwalbe'
  ) {
    return;
  }
  if (window.AS51WunschfarbeInit) return;
  window.AS51WunschfarbeInit = true;

  var PARAM = 'wunschfarbe';
  var DEFAULT_HEX = 'B0B0B0';
  var WHEEL_CSS = 160;
  var WHEEL_CSS_MOBILE = 96;
  // Angle-tdaIds der Lack-Teile (Punkte in GLB-Namen fallen in tdaId weg).
  var LACKSET_MESH_IDS_S51 = ['mesh_0_176nr003', 'mesh_0_176nr003_59', 'mesh_0_176nr007_1'];
  var LACKSET_MESH_IDS_SCHWALBE = [
    'verkleidung_motortunnel_0',
    'fahrwerk_schwinge-v_dynamic_0',
    'verkleidung_beinschild_4',
    'verkleidung_schutzblech-v_0',
    'verkleidung_lenkerabdeckung_dynamic_0',
    'verkleidung_lampe_0',
    'verkleidung_heckpanzer_0',
    'verkleidung_beinschild_0',
  ];

  function isSchwalbeHandle() {
    return window.AS51ProductHandle === '3d-konfigurator-schwalbe';
  }

  function paintMeshIds() {
    return isSchwalbeHandle() ? LACKSET_MESH_IDS_SCHWALBE : LACKSET_MESH_IDS_S51;
  }
  var RAL = [
    ['1000', 'C5BB8A'], ['1001', 'C2B078'], ['1002', 'D6C275'], ['1003', 'F7BA0B'],
    ['1004', 'DC9D00'], ['1005', 'C48700'], ['1006', 'C47300'], ['1007', 'CB6F00'],
    ['1011', 'AF8A54'], ['1012', 'C8B800'], ['1013', 'E3D9C6'], ['1014', 'D9C7A0'],
    ['1015', 'E6D2B5'], ['1016', 'EAF222'], ['1017', 'F0A202'], ['1018', 'F0C800'],
    ['1019', 'A4957A'], ['1020', '9A8B4F'], ['1021', 'E6B800'], ['1023', 'F7B500'],
    ['1024', 'B89C50'], ['1027', 'A38C00'], ['1028', 'FF9B0D'], ['1032', 'DDB20C'],
    ['1033', 'F39F18'], ['1034', 'EFA94A'], ['2000', 'DD7907'], ['2001', 'BE4E24'],
    ['2002', 'C63927'], ['2003', 'F67828'], ['2004', 'E25303'], ['2008', 'F3752C'],
    ['2009', 'E75B12'], ['2010', 'D4652F'], ['2011', 'EC7C25'], ['2012', 'DB6A50'],
    ['3000', 'A72920'], ['3001', '9B2423'], ['3002', '9B2321'], ['3003', '861A22'],
    ['3004', '6B1C23'], ['3005', '59191F'], ['3009', '6D332C'], ['3011', '781F1C'],
    ['3012', 'C1876B'], ['3013', '9C322E'], ['3016', 'B24733'], ['3017', 'CB3334'],
    ['3018', 'CC333C'], ['3020', 'C1121C'], ['3022', 'D56D56'], ['3027', 'B42041'],
    ['3028', 'E72512'], ['3031', 'AC323B'], ['4001', '816183'], ['4002', '8F3A4F'],
    ['4003', 'C4618C'], ['4004', '69193B'], ['4005', '76689A'], ['4006', '923A80'],
    ['4007', '47243C'], ['4008', '854D8E'], ['4009', '9D8692'], ['4010', 'CF3476'],
    ['5000', '314F6F'], ['5001', '1F4764'], ['5002', '163A66'], ['5003', '1D3656'],
    ['5004', '1D1F2A'], ['5005', '154889'], ['5007', '3B6B88'], ['5008', '2B3A44'],
    ['5009', '245878'], ['5010', '13447C'], ['5011', '1A2B3C'], ['5012', '3481B8'],
    ['5013', '163142'], ['5014', '606D87'], ['5015', '2271B3'], ['5017', '0B518B'],
    ['5018', '3C8B8C'], ['5019', '1B5583'], ['5020', '0D4F4B'], ['5021', '157B7C'],
    ['5022', '282C58'], ['5023', '4D6682'], ['5024', '6A93B0'], ['6000', '327662'],
    ['6001', '266E3B'], ['6002', '2C5B2C'], ['6003', '4E553D'], ['6004', '0E4243'],
    ['6005', '0F4336'], ['6006', '3B3C32'], ['6007', '2B3626'], ['6010', '4D6F39'],
    ['6011', '6C7C59'], ['6016', '00694C'], ['6017', '4C7C41'], ['6018', '59A33F'],
    ['6019', 'B7D9B1'], ['6021', '86A47C'], ['6024', '008351'], ['6025', '5A6E3B'],
    ['6026', '005C54'], ['6027', '7EB7BD'], ['6029', '006F4F'], ['6032', '0F8558'],
    ['6033', '46877F'], ['6034', '7FB0B2'], ['6037', '008B29'], ['7000', '7A888E'],
    ['7001', '8C969D'], ['7002', '817863'], ['7003', '7A7B6D'], ['7004', '9B9B9B'],
    ['7005', '6C6E6B'], ['7011', '52595D'], ['7012', '575E62'], ['7015', '4F545A'],
    ['7016', '383E42'], ['7021', '2F3234'], ['7023', '808076'], ['7024', '45494E'],
    ['7030', '928E85'], ['7031', '5B686D'], ['7032', 'B5B0A1'], ['7035', 'C5C7C4'],
    ['7036', '979392'], ['7037', '7A7B7A'], ['7038', 'B0B3A9'], ['7039', '6B665E'],
    ['7040', '989EA1'], ['7042', '8E9699'], ['7043', '4E5454'], ['7044', 'B7B3A8'],
    ['7047', 'C8C8C7'], ['8000', '89693E'], ['8001', '9D622B'], ['8002', '7B4B3A'],
    ['8003', '734222'], ['8004', '8A4B38'], ['8011', '5A3826'], ['8012', '66332B'],
    ['8014', '4A3526'], ['8015', '5E2F26'], ['8016', '4C2B20'], ['8017', '44322D'],
    ['8019', '3D3635'], ['8022', '1A171C'], ['8023', 'A45729'], ['8024', '755847'],
    ['8025', '755C49'], ['8028', '4E3B2B'], ['9001', 'E9E0D2'], ['9002', 'D7D5CB'],
    ['9003', 'ECECE7'], ['9004', '2B2B2C'], ['9005', '0E0E10'], ['9006', 'A1A1A0'],
    ['9007', '878581'], ['9010', 'F1EDE1'], ['9011', '1B1918'], ['9016', 'F1F0EA'],
    ['9017', '2A2928'], ['9018', 'C8CBC4']
  ];
  var WUNSCH_RE = /w[uü]nsch\s*farbe/i;
  var LACKSET_RE = /lackset/i;
  var FARBE_RE = /^\s*farbe\s*$/i;
  var ABREX_RE = /premiumlack|\babrex\b/i;

  var state = {
    active: false,
    hex: DEFAULT_HEX,
    h: 0,
    s: 0,
    v: 0.69,
    meshIds: [],
    panel: null,
    injecting: false,
    dragging: false,
    dismissed: false,
    reopenBound: false,
    observed: null,
    applyTimer: 0,
    applyFrame: 0,
    delayedApplyTimer: 0,
    loadedApplyTimer: 0,
    lacksetReplayTimer: 0,
    lacksetScheduled: false,
    threeHooked: false,
    lacksetUserTouched: false,
    lacksetTouchBound: false,
    lacksetRetriggering: false,
    replaying: false,
    open: true,
    committed: DEFAULT_HEX,
    wheelCache: null,
  };

  function clamp(n, a, b) {
    return n < a ? a : n > b ? b : n;
  }

  function pad2(n) {
    var s = n.toString(16);
    return s.length < 2 ? '0' + s : s;
  }

  function rgbToHex(r, g, b) {
    return (pad2(r) + pad2(g) + pad2(b)).toUpperCase();
  }

  function parseHex(raw) {
    if (!raw) return '';
    var h = String(raw).replace('#', '').toUpperCase();
    if (/^[0-9A-F]{3}$/.test(h)) {
      h = h.charAt(0) + h.charAt(0) + h.charAt(1) + h.charAt(1) + h.charAt(2) + h.charAt(2);
    }
    return /^[0-9A-F]{6}$/.test(h) ? h : '';
  }

  function hexToRgb(hex) {
    var h = parseHex(hex);
    if (!h) return null;
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
  }

  function hsvToRgb(h, s, v) {
    h = ((h % 360) + 360) % 360;
    var c = v * s;
    var x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    var m = v - c;
    var r = 0;
    var g = 0;
    var b = 0;
    if (h < 60) {
      r = c;
      g = x;
    } else if (h < 120) {
      r = x;
      g = c;
    } else if (h < 180) {
      g = c;
      b = x;
    } else if (h < 240) {
      g = x;
      b = c;
    } else if (h < 300) {
      r = x;
      b = c;
    } else {
      r = c;
      b = x;
    }
    return [Math.round((r + m) * 255), Math.round((g + m) * 255), Math.round((b + m) * 255)];
  }

  function rgbToHsv(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var d = max - min;
    var h = 0;
    var s = max === 0 ? 0 : d / max;
    if (d !== 0) {
      if (max === r) h = ((g - b) / d + (g < b ? 6 : 0)) * 60;
      else if (max === g) h = ((b - r) / d + 2) * 60;
      else h = ((r - g) / d + 4) * 60;
    }
    return { h: h, s: s, v: max };
  }

  function hexToHsv(hex) {
    var rgb = hexToRgb(hex);
    if (!rgb) return { h: 0, s: 0, v: 0.69 };
    return rgbToHsv(rgb[0], rgb[1], rgb[2]);
  }

  function hsvToHex(h, s, v) {
    var rgb = hsvToRgb(h, s, v);
    return rgbToHex(rgb[0], rgb[1], rgb[2]);
  }

  function nearestRal(hex) {
    var rgb = hexToRgb(hex);
    if (!rgb) return null;
    var best = null;
    var bestD = Infinity;
    for (var i = 0; i < RAL.length; i++) {
      var hr = parseInt(RAL[i][1].slice(0, 2), 16);
      var hg = parseInt(RAL[i][1].slice(2, 4), 16);
      var hb = parseInt(RAL[i][1].slice(4, 6), 16);
      var d = (rgb[0] - hr) * (rgb[0] - hr) + (rgb[1] - hg) * (rgb[1] - hg) + (rgb[2] - hb) * (rgb[2] - hb);
      if (d < bestD) {
        bestD = d;
        best = RAL[i];
      }
    }
    return best ? { code: best[0], hex: best[1] } : null;
  }

  function paintLabel(hex) {
    var clean = parseHex(hex);
    var ral = nearestRal(clean);
    var label = '#' + clean;
    if (ral) label += ' · RAL ' + ral.code;
    return label;
  }

  function isMobileUi() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function wheelSize() {
    return isMobileUi() ? WHEEL_CSS_MOBILE : WHEEL_CSS;
  }

  function getViewer() {
    return document.querySelector('tda-model-viewer') || document.querySelector('model-viewer');
  }

  function sceneFrom(el) {
    if (!el) return null;
    try {
      var keys = Reflect.ownKeys(el);
      for (var i = 0; i < keys.length; i++) {
        if (String(keys[i]).trim() !== 'Symbol(scene)') continue;
        var scene = el[keys[i]];
        if (scene && typeof scene.traverse === 'function') return scene;
      }
    } catch (e) {
      /* ignore */
    }
    return null;
  }

  function getScene(viewer) {
    var scene = sceneFrom(viewer);
    if (scene) return scene;
    try {
      if (viewer && viewer.shadowRoot) {
        var inner = viewer.shadowRoot.querySelector('model-viewer');
        scene = sceneFrom(inner);
        if (scene) return scene;
      }
    } catch (e) {
      /* ignore */
    }
    return null;
  }

  function meshId(obj) {
    if (!obj) return '';
    if (obj.userData && obj.userData.tdaId) return String(obj.userData.tdaId);
    return obj.name ? String(obj.name) : '';
  }

  function normId(id) {
    return String(id || '')
      .toLowerCase()
      .replace(/\./g, '');
  }

  function paintMeshNorm() {
    var ids = paintMeshIds();
    var out = [];
    for (var li = 0; li < ids.length; li++) out.push(normId(ids[li]));
    return out;
  }

  function isLacksetMesh(obj) {
    if (!obj || !obj.isMesh) return false;
    var norms = paintMeshNorm();
    var n = normId(meshId(obj));
    if (n && norms.indexOf(n) !== -1) return true;
    n = normId(obj.name);
    return !!(n && norms.indexOf(n) !== -1);
  }

  function snapshotMeshes() {
    var scene = getScene(getViewer());
    if (!scene) return;
    var ids = paintMeshIds().slice();
    scene.traverse(function (obj) {
      if (!isLacksetMesh(obj)) return;
      var id = meshId(obj);
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    state.meshIds = ids;
    watchLacksetMeshes();
  }

  function colorSetHex(material, hex) {
    if (!material || !material.color) return false;
    var n = parseInt('0x' + hex, 16);
    if (isNaN(n)) return false;
    try {
      if (typeof material.color.setHex === 'function') material.color.setHex(n);
      else if (typeof material.color.setRGB === 'function') {
        material.color.setRGB(((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255);
      } else {
        material.color.r = ((n >> 16) & 255) / 255;
        material.color.g = ((n >> 8) & 255) / 255;
        material.color.b = (n & 255) / 255;
      }
      material.needsUpdate = true;
      return true;
    } catch (e) {
      return false;
    }
  }

  function applyOnScene(hex) {
    var scene = getScene(getViewer());
    if (!scene) return false;
    var painted = 0;
    scene.traverse(function (obj) {
      if (!isLacksetMesh(obj)) return;
      if (colorSetHex(obj.material, hex)) {
        if (!obj.userData) obj.userData = {};
        obj.userData.materialUpdated = true;
        painted += 1;
      }
    });
    if (painted) scene.isDirty = true;
    return painted > 0;
  }

  function applyHex(hex) {
    if (!hasSelectedWunsch()) return false;
    var clean = parseHex(hex);
    if (!clean) return false;
    applyOnScene(clean);
    tintSwatch(clean);
    return true;
  }

  function rememberLacksetHex(obj, hex) {
    var clean = parseHex(hex);
    if (!clean || !obj) return;
    if (!obj.userData) obj.userData = {};
    if (clean === 'FFFFFF' && obj.userData._as51appliedHex && obj.userData._as51appliedHex !== 'FFFFFF') {
      return;
    }
    obj.userData._as51appliedHex = clean;
  }

  function wrapColorSetHex(obj, color) {
    if (!color || color._as51hexWatch) return;
    var orig = color.setHex;
    if (typeof orig !== 'function') return;
    color._as51hexWatch = true;
    color.setHex = function (hex) {
      var result = orig.apply(this, arguments);
      var str = '';
      try {
        str = this.getHexString ? String(this.getHexString()).toUpperCase() : '';
      } catch (err) {
        str = '';
      }
      rememberLacksetHex(obj, str);
      return result;
    };
  }

  function hookColorProto(proto) {
    if (!proto || proto._as51hooked || typeof proto.setHex !== 'function') return false;
    var orig = proto.setHex;
    proto._as51hooked = true;
    proto.setHex = function (hex) {
      var result = orig.apply(this, arguments);
      if (state.replaying) return result;
      try {
        var str = this.getHexString ? String(this.getHexString()).toUpperCase() : '';
        if (!parseHex(str)) return result;
        var scene = getScene(getViewer());
        if (!scene) return result;
        var color = this;
        scene.traverse(function (obj) {
          if (!isLacksetMesh(obj) || !obj.material) return;
          if (obj.material.color === color) rememberLacksetHex(obj, str);
        });
      } catch (err) {
        /* ignore */
      }
      return result;
    };
    return true;
  }

  function hookThreeColorProto() {
    if (state.threeHooked) return true;
    if (window.THREE && window.THREE.Color && hookColorProto(window.THREE.Color.prototype)) {
      state.threeHooked = true;
      return true;
    }
    return false;
  }

  function watchLacksetMesh(obj) {
    if (!obj || !obj.isMesh || !isLacksetMesh(obj)) return;
    if (!obj.userData) obj.userData = {};
    var color = obj.material && obj.material.color;
    if (color && color.constructor) hookColorProto(color.constructor.prototype);
    wrapColorSetHex(obj, color);
  }

  function watchLacksetMeshes() {
    var scene = getScene(getViewer());
    if (!scene) return false;
    scene.traverse(watchLacksetMesh);
    return true;
  }

  function recordedLacksetHex() {
    var scene = getScene(getViewer());
    if (!scene) return '';
    var found = '';
    scene.traverse(function (obj) {
      if (found || !isLacksetMesh(obj) || !obj.userData) return;
      var hex = parseHex(obj.userData._as51appliedHex);
      if (hex) found = hex;
    });
    return found;
  }

  function replayAngleLacksetColor() {
    if (hasSelectedWunsch()) return false;
    var hex = recordedLacksetHex();
    if (!hex) return false;
    var scene = getScene(getViewer());
    if (!scene) return false;
    var painted = 0;
    state.replaying = true;
    try {
      scene.traverse(function (obj) {
        if (!obj || !obj.isMesh) return;
        var match = isLacksetMesh(obj);
        if (!match && obj.userData && parseHex(obj.userData._as51appliedHex)) match = true;
        if (!match) return;
        if (colorSetHex(obj.material, hex)) {
          if (!obj.userData) obj.userData = {};
          obj.userData.materialUpdated = true;
          painted += 1;
        }
      });
      if (painted) scene.isDirty = true;
    } finally {
      state.replaying = false;
    }
    return painted > 0;
  }

  function findSelectedStandardLackset() {
    var titles = document.querySelectorAll('.tda-customizer-customization-option-title');
    for (var i = 0; i < titles.length; i++) {
      var text = titles[i].textContent || '';
      if (!LACKSET_RE.test(text) && !FARBE_RE.test(text) && !/farbe/i.test(text)) continue;
      var option = titles[i].closest('.tda-customizer-customization-option');
      if (!option) continue;
      if (option.closest('.swiper-summary-container-customization-option')) continue;
      var sel = option.querySelector(
        '.tda-customizer-customization-option-value.tda-customizer-customization-option-value-selected',
      );
      if (!sel) continue;
      if (sel.getAttribute('tda-variant-option-value') === 'Wunschfarbe') return null;
      if (typeof isSchwalbeHandle === 'function' && isSchwalbeHandle() && typeof isWunschNode === 'function' && isWunschNode(sel)) {
        return null;
      }
      return sel;
    }
    return null;
  }

  function retriggerSelectedLackset() {
    var swatch = findSelectedStandardLackset();
    if (!swatch || typeof swatch.click !== 'function') return false;
    var viewer = getViewer();
    var orbit = viewer && viewer.cameraOrbit;
    var fov = viewer && viewer.fieldOfView;
    var target = viewer && viewer.cameraTarget;
    state.lacksetRetriggering = true;
    try {
      swatch.click();
    } catch (e) {
      state.lacksetRetriggering = false;
      return false;
    }
    window.setTimeout(function () {
      state.lacksetRetriggering = false;
      if (!viewer) return;
      try {
        if (orbit) viewer.cameraOrbit = orbit;
        if (fov) viewer.fieldOfView = fov;
        if (target) viewer.cameraTarget = target;
      } catch (err) {
        /* ignore */
      }
    }, 80);
    return true;
  }

  function currentLacksetHex() {
    var scene = getScene(getViewer());
    if (!scene) return '';
    var found = '';
    scene.traverse(function (obj) {
      if (found || !obj || !obj.isMesh || !obj.material || !obj.material.color) return;
      if (!isLacksetMesh(obj) && !(obj.userData && obj.userData._as51appliedHex)) return;
      try {
        found = parseHex(obj.material.color.getHexString && obj.material.color.getHexString());
      } catch (e) {
        found = '';
      }
    });
    return found;
  }

  function finishRestoredPaint(allowClick) {
    hookThreeColorProto();
    watchLacksetMeshes();
    if (hasSelectedWunsch()) {
      snapshotMeshes();
      applyHex(state.hex);
      return true;
    }
    if (state.lacksetUserTouched) return true;
    var wanted = recordedLacksetHex();
    replayAngleLacksetColor();
    if (wanted && currentLacksetHex() === wanted) return true;
    if (!allowClick) return false;
    retriggerSelectedLackset();
    return currentLacksetHex() === wanted;
  }

  function bindLacksetUserTouch() {
    if (state.lacksetTouchBound) return;
    var wrap = document.querySelector('.tda-customizer-wrapper');
    if (!wrap) return;
    state.lacksetTouchBound = true;
    wrap.addEventListener(
      'click',
      function (ev) {
        if (state.lacksetRetriggering) return;
        var t = ev.target;
        if (!t || !t.closest) return;
        var val = t.closest('.tda-customizer-customization-option-value');
        if (!val) return;
        var option = val.closest('.tda-customizer-customization-option');
        if (!option || option.closest('.swiper-summary-container-customization-option')) return;
        var title = option.querySelector('.tda-customizer-customization-option-title');
        var text = title ? title.textContent || '' : '';
        if (LACKSET_RE.test(text) || FARBE_RE.test(text) || /farbe/i.test(text)) {
          state.lacksetUserTouched = true;
        }
      },
      true,
    );
  }

  function scheduleLacksetReplay() {
    hookThreeColorProto();
    watchLacksetMeshes();
    if (state.lacksetScheduled) return;
    state.lacksetScheduled = true;
    var attempts = 0;
    function tick() {
      attempts += 1;
      finishRestoredPaint(attempts >= 10);
      if (state.lacksetUserTouched || attempts >= 40) return;
      state.lacksetReplayTimer = window.setTimeout(tick, 250);
    }
    state.lacksetReplayTimer = window.setTimeout(tick, 80);
  }

  function cancelApply() {
    if (state.applyTimer) window.clearTimeout(state.applyTimer);
    if (state.applyFrame) window.cancelAnimationFrame(state.applyFrame);
    if (state.delayedApplyTimer) window.clearTimeout(state.delayedApplyTimer);
    if (state.loadedApplyTimer) window.clearTimeout(state.loadedApplyTimer);
    state.applyTimer = 0;
    state.applyFrame = 0;
    state.delayedApplyTimer = 0;
    state.loadedApplyTimer = 0;
  }

  function queueApply() {
    if (state.applyTimer) return;
    state.applyTimer = window.setTimeout(function () {
      state.applyTimer = 0;
      applyHex(state.hex);
    }, 160);
  }

  function updateRawQueryParam(search, name, value) {
    var raw = String(search || '').replace(/^\?/, '');
    var key = encodeURIComponent(name);
    var parts = raw ? raw.split('&') : [];
    var next = [];
    for (var i = 0; i < parts.length; i++) {
      var partKey = parts[i].split('=', 1)[0];
      if (partKey !== key) next.push(parts[i]);
    }
    if (value !== '') next.push(key + '=' + encodeURIComponent(value));
    return next.length ? '?' + next.join('&') : '';
  }

  function persistUrl(hex) {
    try {
      var search = window.location.search;
      if (state.active && hasSelectedWunsch() && hex) {
        search = updateRawQueryParam(search, PARAM, parseHex(hex) || DEFAULT_HEX);
        var ral = nearestRal(hex);
        search = updateRawQueryParam(search, 'wunschral', ral ? ral.code : '');
      } else {
        search = updateRawQueryParam(search, PARAM, '');
        search = updateRawQueryParam(search, 'wunschral', '');
      }
      var next = window.location.pathname + search + window.location.hash;
      if (next !== window.location.pathname + window.location.search + window.location.hash) {
        history.replaceState(null, '', next);
      }
    } catch (e) {
      /* ignore */
    }
  }

  function injectProperty(items, hex) {
    if (!items || !items.length) return;
    var value = paintLabel(hex);
    var ral = nearestRal(hex);
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it || !it.properties) continue;
      if (String(it.properties._isParent) === 'true') {
        it.properties.Wunschfarbe = value;
        if (ral) it.properties.RAL = ral.code;
      }
    }
  }

  function injectIntoBody(body, hex) {
    if (!hex || body == null) return body;
    if (typeof body === 'object' && body.items) {
      injectProperty(body.items, hex);
      return body;
    }
    if (typeof body !== 'string') return body;
    var trimmed = body.replace(/^\s+/, '');
    if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
      try {
        var parsed = JSON.parse(body);
        if (parsed && parsed.items) injectProperty(parsed.items, hex);
        else if (parsed && parsed.length) injectProperty(parsed, hex);
        return JSON.stringify(parsed);
      } catch (e) {
        return body;
      }
    }
    // Angle (jQuery) schickt die Klammern URL-kodiert: items%5B28%5D%5Bproperties%5D…
    // — beide Schreibweisen erkennen, sonst landen Wunschfarbe/RAL nie am Parent.
    var L = '(?:\\[|%5B)';
    var R = '(?:\\]|%5D)';
    var match = body.match(
      new RegExp('items' + L + '(\\d+)' + R + L + 'properties' + R + L + '_isParent' + R + '=true', 'i')
    );
    if (!match) return body;
    var idx = match[1];
    var prefix = 'items%5B' + idx + '%5D%5Bproperties%5D%5B';
    var ral = nearestRal(hex);
    var fields = [['Wunschfarbe', paintLabel(hex)]];
    if (ral) fields.push(['RAL', ral.code]);
    for (var f = 0; f < fields.length; f++) {
      var name = fields[f][0];
      var pair = prefix + name + '%5D=' + encodeURIComponent(fields[f][1]);
      var existing = new RegExp(
        'items' + L + idx + R + L + 'properties' + R + L + name + R + '=[^&]*',
        'i'
      );
      body = existing.test(body) ? body.replace(existing, pair) : body + '&' + pair;
    }
    return body;
  }

  function hookCart() {
    if (window.AS51WunschfarbeCartHook) return;
    window.AS51WunschfarbeCartHook = true;

    var xhrOpen = XMLHttpRequest.prototype.open;
    var xhrSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        this._as51url = String(url || '');
      } catch (e) {
        this._as51url = '';
      }
      return xhrOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (
          state.active &&
          hasSelectedWunsch() &&
          state.hex &&
          this._as51url &&
          this._as51url.indexOf('cart/add.js') !== -1
        ) {
          body = injectIntoBody(body, state.hex);
        }
      } catch (e) {
        /* fail-open */
      }
      return xhrSend.call(this, body);
    };

    if (typeof window.fetch === 'function') {
      var origFetch = window.fetch;
      window.fetch = function (input, init) {
        try {
          var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
          if (state.active && hasSelectedWunsch() && state.hex && String(url).indexOf('cart/add.js') !== -1) {
            init = init ? Object.assign({}, init) : {};
            if (init.body) init.body = injectIntoBody(init.body, state.hex);
            return origFetch.call(this, input, init);
          }
        } catch (e) {
          /* fail-open */
        }
        return origFetch.apply(this, arguments);
      };
    }
  }

  function isShown(el) {
    if (!el) return false;
    if (el.style && el.style.display === 'none') return false;
    try {
      var cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') return false;
      var box = el.getBoundingClientRect();
      if (box.width === 0 && box.height === 0) return false;
    } catch (e) {
      /* ignore */
    }
    return true;
  }

  function isWunschLabel(text) {
    var t = String(text || '').replace(/\s+/g, ' ').trim();
    if (!WUNSCH_RE.test(t)) return false;
    if (/kommentar/i.test(t)) return false;
    return true;
  }

  function nodeLabel(el) {
    if (!el) return '';
    var bits = [];
    try {
      bits.push(el.getAttribute('tda-variant-option-value'));
    } catch (e) {
      /* ignore */
    }
    bits.push(el.textContent);
    var parent = el.parentNode;
    if (parent && parent.querySelector) {
      var info = parent.querySelector('.swiper-option-value-info');
      if (info) bits.push(info.textContent);
    }
    var slide =
      el.classList && el.classList.contains('option-value-swiper-slide')
        ? el
        : el.closest
          ? el.closest('.option-value-swiper-slide')
          : null;
    if (slide && slide !== el) bits.push(slide.textContent);
    return bits.join(' ');
  }

  function isWunschNode(el) {
    return isWunschLabel(nodeLabel(el));
  }

  function wizardOnPaintStep() {
    var nodes = document.querySelectorAll(
      '.tda-customizer-customization-options-container > .swiper-container'
    );
    var root = null;
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].classList.contains('option-value-swiper-container')) continue;
      if (/option-value/.test(nodes[i].id || '')) continue;
      root = nodes[i];
      break;
    }
    if (!root) return true;
    var strong = root.querySelector('.swiper-slide-active strong');
    if (!strong) return true;
    var text = strong.textContent || '';
    return LACKSET_RE.test(text) || FARBE_RE.test(text) || ABREX_RE.test(text);
  }

  function findPaintGroup() {
    var titles = document.querySelectorAll('.tda-customizer-customization-option-title');
    var lackset = null;
    var abrex = null;
    for (var i = 0; i < titles.length; i++) {
      var text = titles[i].textContent || '';
      var option = titles[i].closest('.tda-customizer-customization-option');
      if (!option) continue;
      if (option.closest('.swiper-summary-container-customization-option')) continue;
      if (LACKSET_RE.test(text) || FARBE_RE.test(text)) lackset = option;
      if (ABREX_RE.test(text)) abrex = option;
    }
    if (abrex && findSelectedWunsch(abrex)) return abrex;
    if (lackset && findSelectedWunsch(lackset)) return lackset;
    if (abrex && isShown(abrex)) return abrex;
    if (lackset && isShown(lackset)) return lackset;
    return abrex || lackset;
  }

  function findLacksetGroup() {
    return findPaintGroup();
  }

  function findSelectedWunsch(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll('.tda-customizer-customization-option-value-selected');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].closest('.swiper-summary-container-customization-option')) continue;
      if (!nodes[i].classList.contains('tda-customizer-customization-option-value')) continue;
      if (nodes[i].getAttribute('tda-variant-option-value') === 'Wunschfarbe') return nodes[i];
      if (
        typeof isSchwalbeHandle === 'function' &&
        isSchwalbeHandle() &&
        typeof isWunschNode === 'function' &&
        isWunschNode(nodes[i])
      ) {
        return nodes[i];
      }
    }
    return null;
  }

  function hasSelectedWunsch() {
    return !!findSelectedWunsch(document);
  }

  function findVisibleWunsch() {
    var containers = document.querySelectorAll('.option-value-swiper-container');
    for (var i = 0; i < containers.length; i++) {
      var c = containers[i];
      // Vom offenen Farbkreis verdeckte Swatch-Zeile zählt weiter als sichtbar.
      if (!isShown(c) && !c.classList.contains('wh-wunsch-covered')) continue;
      var sel = findSelectedWunsch(c);
      if (sel) return { swatch: sel, root: c };
    }
    var group = findLacksetGroup();
    if (group) {
      var gsel = findSelectedWunsch(group);
      if (gsel) return { swatch: gsel, root: group };
    }
    var any = findSelectedWunsch(document);
    if (any && isShown(any)) {
      var host =
        any.closest('.tda-customizer-customization-option') ||
        any.closest('.option-value-swiper-container');
      if (host && isShown(host)) return { swatch: any, root: host };
    }
    return null;
  }

  function mountTarget() {
    var found = findVisibleWunsch();
    if (found && found.root) return found.root;
    var group = findLacksetGroup();
    if (group) return group;
    var opts = document.querySelector('.tda-customizer-customization-options-container');
    return opts || null;
  }

  function qs(sel) {
    return state.panel ? state.panel.querySelector(sel) : null;
  }

  function ensureWheelCache(ctx, size) {
    if (state.wheelCache && state.wheelCache.size === size) return state.wheelCache.image;
    var image = ctx.createImageData(size, size);
    var data = image.data;
    var cx = size / 2;
    var cy = size / 2;
    var radius = size / 2 - 1;
    for (var y = 0; y < size; y++) {
      for (var x = 0; x < size; x++) {
        var dx = x + 0.5 - cx;
        var dy = y + 0.5 - cy;
        var dist = Math.sqrt(dx * dx + dy * dy);
        var idx = (y * size + x) * 4;
        if (dist > radius) {
          data[idx + 3] = 0;
          continue;
        }
        var hue = (Math.atan2(dy, dx) * 180) / Math.PI;
        if (hue < 0) hue += 360;
        var sat = dist / radius;
        var rgb = hsvToRgb(hue, sat, 1);
        data[idx] = rgb[0];
        data[idx + 1] = rgb[1];
        data[idx + 2] = rgb[2];
        data[idx + 3] = 255;
      }
    }
    state.wheelCache = { size: size, image: image };
    return image;
  }

  function positionHandle(size) {
    var handle = qs('[data-wh-handle]');
    if (!handle) return;
    var radius = size / 2 - 1;
    var markerR = (state.s || 0) * radius;
    var rad = ((state.h || 0) * Math.PI) / 180;
    var mx = size / 2 + Math.cos(rad) * markerR;
    var my = size / 2 + Math.sin(rad) * markerR;
    handle.style.left = (mx / size) * 100 + '%';
    handle.style.top = (my / size) * 100 + '%';
    handle.style.backgroundColor = '#' + state.hex;
  }

  function drawWheel() {
    var canvas = qs('[data-wh-wheel]');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    var size = wheelSize();
    if (canvas.width !== size) {
      canvas.width = size;
      canvas.height = size;
    }
    ctx.putImageData(ensureWheelCache(ctx, size), 0, 0);
    positionHandle(size);
  }

  function syncInputs() {
    if (!state.panel) return;
    var chip = qs('[data-wh-chip]');
    var hexField = qs('[data-wh-hex]');
    var value = qs('[data-wh-value]');
    var ralNode = qs('[data-wh-ral]');
    var hintMob = qs('[data-wh-hint-mob]');
    var hash = '#' + state.hex;
    var ral = nearestRal(state.hex);
    if (chip) chip.style.backgroundColor = hash;
    if (hexField && document.activeElement !== hexField) hexField.value = hash;
    if (value) value.value = String(Math.round((state.v || 0) * 100));
    if (ralNode) ralNode.textContent = ral ? 'RAL ' + ral.code : '—';
    if (hintMob) {
      hintMob.textContent = ral
        ? 'Nächster RAL ' + ral.code + ': Lackmuster kommt vorab per Post.'
        : 'Lackmuster kommt vorab per Post.';
    }
    drawWheel();
  }

  function markFreiSwatches() {
    var nodes = document.querySelectorAll('.tda-customizer-customization-option-value');
    for (var i = 0; i < nodes.length; i++) {
      if (!isWunschNode(nodes[i])) continue;
      nodes[i].classList.add('wh-frei-swatch');
    }
  }

  function tintSwatch(hex) {
    var swatch = findSelectedWunsch(document);
    if (!swatch) return;
    swatch.style.backgroundImage = 'none';
    swatch.style.backgroundColor = '#' + parseHex(hex);
  }

  function setFromHsv(h, s, v, persist) {
    if (s > 0.001) state.h = h;
    state.s = clamp(s, 0, 1);
    state.v = clamp(v, 0, 1);
    state.hex = hsvToHex(state.h, state.s, state.v);
    syncInputs();
    applyHex(state.hex);
    if (persist !== false) persistUrl(state.hex);
  }

  function setFromHex(hex, persist) {
    var clean = parseHex(hex);
    if (!clean) return;
    var hsv = hexToHsv(clean);
    if (hsv.s > 0.001) state.h = hsv.h;
    state.s = hsv.s;
    state.v = hsv.v;
    state.hex = clean;
    syncInputs();
    applyHex(state.hex);
    if (persist !== false) persistUrl(state.hex);
  }

  function pickFromEvent(ev) {
    var canvas = qs('[data-wh-wheel]');
    if (!canvas) return;
    var size = wheelSize();
    var rect = canvas.getBoundingClientRect();
    var x = ev.clientX - rect.left;
    var y = ev.clientY - rect.top;
    var dx = (x * size) / rect.width - size / 2;
    var dy = (y * size) / rect.height - size / 2;
    var dist = Math.sqrt(dx * dx + dy * dy);
    var radius = size / 2 - 1;
    if (dist > radius + 16) return;
    var hue = (Math.atan2(dy, dx) * 180) / Math.PI;
    if (hue < 0) hue += 360;
    var sat = clamp(dist / radius, 0, 1);
    setFromHsv(hue, sat, state.v, true);
  }

  function bindPanel(panel) {
    var canvas = panel.querySelector('[data-wh-wheel]');
    var hexField = panel.querySelector('[data-wh-hex]');
    var value = panel.querySelector('[data-wh-value]');

    function stop(ev) {
      ev.stopPropagation();
    }
    panel.addEventListener('click', stop);
    panel.addEventListener('pointerdown', stop);

    // Mobil: X schließt das Overlay; die gewählte Farbe bleibt. Erneutes
    // Tippen auf „Wunschfarbe“ öffnet es wieder (siehe bindWunschReopen).
    var close = panel.querySelector('[data-wh-close]');
    if (close) {
      close.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        state.dismissed = true;
        state.injecting = true;
        panel.hidden = true;
        setCovered(null);
        state.injecting = false;
      });
    }

    if (canvas) {
      canvas.addEventListener('pointerdown', function (ev) {
        state.dragging = true;
        try {
          canvas.setPointerCapture(ev.pointerId);
        } catch (e) {
          /* ignore */
        }
        pickFromEvent(ev);
      });
      canvas.addEventListener('pointermove', function (ev) {
        if (!state.dragging) return;
        pickFromEvent(ev);
      });
      canvas.addEventListener('pointerup', function () {
        state.dragging = false;
      });
      canvas.addEventListener('pointercancel', function () {
        state.dragging = false;
      });
    }

    if (hexField) {
      hexField.addEventListener('change', function () {
        setFromHex(hexField.value, true);
      });
      hexField.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter') {
          ev.preventDefault();
          setFromHex(hexField.value, true);
        }
      });
    }
    if (value) {
      value.addEventListener('input', function () {
        setFromHsv(state.h, state.s, Number(value.value) / 100, true);
      });
    }
  }

  function buildPanel() {
    var panel = document.createElement('div');
    panel.id = 'wh-wunschfarbe';
    panel.className = 'wh-wunschfarbe';
    panel.hidden = true;
    panel.innerHTML =
      '<button type="button" class="wh-wunschfarbe__close" data-wh-close aria-label="Farbkreis schließen">' +
      '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path fill="currentColor" d="M2.1 1 6 4.9 9.9 1 11 2.1 7.1 6 11 9.9 9.9 11 6 7.1 2.1 11 1 9.9 4.9 6 1 2.1z"/></svg>' +
      '</button>' +
      '<div class="wh-wunschfarbe__body">' +
      '<div class="wh-wunschfarbe__stage">' +
      '<canvas class="wh-wunschfarbe__wheel" data-wh-wheel width="160" height="160" aria-label="Farbkreis"></canvas>' +
      '<span class="wh-wunschfarbe__handle" data-wh-handle aria-hidden="true"></span>' +
      '</div>' +
      '<div class="wh-wunschfarbe__side">' +
      '<h3 class="wh-wunschfarbe__title">Wunschfarbe</h3>' +
      '<div class="wh-wunschfarbe__field"><span>Nächster RAL</span>' +
      '<div class="wh-wunschfarbe__ral" data-wh-ral>RAL —</div></div>' +
      '<p class="wh-wunschfarbe__hint">Lackiert wird nach RAL. Lackmuster kommt vorab.</p>' +
      '</div>' +
      '<div class="wh-wunschfarbe__slider">' +
      '<span class="wh-wunschfarbe__slider-label">Dunkel</span>' +
      '<input class="wh-wunschfarbe__value" data-wh-value type="range" min="0" max="100" value="69" aria-label="Helligkeit">' +
      '<span class="wh-wunschfarbe__slider-label">Hell</span>' +
      '</div></div>';
    bindPanel(panel);
    return panel;
  }

  function hasMobileWizard() {
    var nodes = document.querySelectorAll(
      '.tda-customizer-customization-options-container > .swiper-container'
    );
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].classList.contains('option-value-swiper-container')) continue;
      return true;
    }
    return false;
  }

  function placePanel(anchor) {
    if (!state.panel || !state.panel.isConnected) {
      state.panel = buildPanel();
    }
    var panel = state.panel;
    panel.classList.remove('is-fixed');

    var host = null;
    var after = null;
    var found = findVisibleWunsch();
    var visibleRoot =
      found && found.root && (isShown(found.root) || found.root.classList.contains('wh-wunsch-covered'))
        ? found.root
        : null;
    if ((isMobileUi() || hasMobileWizard()) && visibleRoot && visibleRoot.parentNode) {
      host = visibleRoot.parentNode;
      after = visibleRoot;
    } else if (anchor && anchor.parentNode) {
      host = anchor.parentNode;
      after = anchor;
    }
    if (!host) return;
    var sheet = !!(
      isMobileUi() &&
      visibleRoot &&
      after === visibleRoot &&
      visibleRoot.classList.contains('option-value-swiper-container')
    );
    state.injecting = true;
    if (panel.parentNode !== host || panel.previousElementSibling !== after) {
      if (after && after.nextSibling) host.insertBefore(panel, after.nextSibling);
      else host.appendChild(panel);
    }
    // Mobil: Farbkreis ersetzt die Swatch-Zeile, solange er offen ist (X
    // schließt ihn, die Swatches kommen zurück) — so passen Moped und Farbkreis
    // zusammen auf einen Screen.
    panel.classList.toggle('is-sheet', sheet);
    panel.hidden = sheet && state.dismissed;
    setCovered(sheet && !panel.hidden ? visibleRoot : null);
    state.injecting = false;
  }

  function setCovered(root) {
    var prev = document.querySelectorAll('.wh-wunsch-covered');
    for (var i = 0; i < prev.length; i++) {
      if (prev[i] !== root) prev[i].classList.remove('wh-wunsch-covered');
    }
    if (root && !root.classList.contains('wh-wunsch-covered')) root.classList.add('wh-wunsch-covered');
  }

  function bindWunschReopen() {
    if (state.reopenBound) return;
    state.reopenBound = true;
    document.addEventListener(
      'click',
      function (ev) {
        var t = ev.target;
        if (!t || !t.closest) return;
        if (t.closest('.wh-wunschfarbe')) return;
        var node = t.closest(
          '[tda-variant-option-value], .tda-customizer-customization-option-value, .option-value-swiper-slide'
        );
        if (node && isWunschNode(node) && state.dismissed) {
          state.dismissed = false;
          window.requestAnimationFrame(function () {
            sync();
            revealPanel();
          });
        }
      },
      true
    );
  }

  function hidePanel() {
    if (state.panel) state.panel.hidden = true;
    if (document.querySelector('.wh-wunsch-covered')) {
      state.injecting = true;
      setCovered(null);
      state.injecting = false;
    }
  }

  function revealPanel() {
    var panel = state.panel;
    if (!panel || panel.hidden) return;
    try {
      var box = panel.getBoundingClientRect();
      var floor = window.innerHeight - 16;
      var sticky = document.querySelector('.wh-sticky-kauf');
      if (sticky) {
        var sr = sticky.getBoundingClientRect();
        if (sr.height) floor = sr.top - 12;
      }
      // Mobil: Moped oben im Bild halten, solange der Farbkreis darunter noch passt.
      var viewer = isMobileUi() ? document.querySelector('tda-model-viewer') : null;
      if (viewer) {
        var vTop = viewer.getBoundingClientRect().top;
        if (box.bottom - vTop <= floor) {
          if (Math.abs(vTop) > 4) window.scrollBy({ top: vTop, left: 0, behavior: 'smooth' });
          return;
        }
      }
      if (box.bottom > floor) {
        window.scrollBy({ top: box.bottom - floor, left: 0, behavior: 'smooth' });
      } else if (box.top < 72) {
        panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    } catch (e) {
      /* ignore */
    }
  }

  function activate() {
    if (!hasSelectedWunsch()) {
      deactivate();
      return;
    }
    var became = !state.active;
    state.active = true;
    persistUrl(state.hex);
    markFreiSwatches();
    syncInputs();
    if (became) {
      state.applyFrame = window.requestAnimationFrame(function () {
        state.applyFrame = 0;
        state.delayedApplyTimer = window.setTimeout(function () {
          state.delayedApplyTimer = 0;
          if (!hasSelectedWunsch()) return;
          snapshotMeshes();
          applyHex(state.hex);
          revealPanel();
        }, 60);
      });
    } else {
      queueApply();
    }
  }

  function deactivate() {
    cancelApply();
    state.dismissed = false;
    state.active = false;
    persistUrl('');
    hidePanel();
  }

  function sync() {
    if (state.injecting) return;
    markFreiSwatches();
    var found = findVisibleWunsch();
    var active = !!found && wizardOnPaintStep();
    var anchor = found && found.root ? found.root : mountTarget();
    if (active && anchor) {
      placePanel(anchor);
      activate();
    } else {
      deactivate();
    }
  }

  function readUrl() {
    try {
      var hex = parseHex(new URLSearchParams(window.location.search).get(PARAM));
      if (hex) {
        var hsv = hexToHsv(hex);
        state.h = hsv.h;
        state.s = hsv.s;
        state.v = hsv.v;
        state.hex = hex;
        state.committed = hex;
      }
    } catch (e) {
      /* ignore */
    }
  }

  function attach() {
    var wrap = document.querySelector('.tda-customizer-wrapper');
    if (!wrap) return false;
    if (wrap !== state.observed) {
      state.observed = wrap;
      var syncQueued = false;
      new MutationObserver(function () {
        if (state.injecting || syncQueued) return;
        syncQueued = true;
        window.requestAnimationFrame(function () {
          syncQueued = false;
          if (!state.injecting) sync();
        });
      }).observe(wrap, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    watchLacksetMeshes();
    bindLacksetUserTouch();
    bindWunschReopen();
    sync();
    return true;
  }

  hookCart();
  readUrl();
  hookThreeColorProto();
  var threeTries = 0;
  var threeTimer = window.setInterval(function () {
    threeTries += 1;
    hookThreeColorProto();
    if (getScene(getViewer())) scheduleLacksetReplay();
    if (state.lacksetScheduled || threeTries >= 400) window.clearInterval(threeTimer);
  }, 50);
  window.addEventListener('Angle3DCustomizerLoaded', function () {
    try {
      hookThreeColorProto();
      scheduleLacksetReplay();
      attach();
      watchLacksetMeshes();
      bindLacksetUserTouch();
    } catch (err) {
      scheduleLacksetReplay();
    }
    if (state.loadedApplyTimer) window.clearTimeout(state.loadedApplyTimer);
    state.loadedApplyTimer = window.setTimeout(function () {
      state.loadedApplyTimer = 0;
      if (hasSelectedWunsch()) {
        snapshotMeshes();
        applyHex(state.hex);
      }
    }, 400);
  });
  window.AS51LacksetDebug = function () {
    return {
      scheduled: !!state.lacksetScheduled,
      threeHooked: !!state.threeHooked,
      rec: recordedLacksetHex(),
      current: currentLacksetHex(),
      userTouched: !!state.lacksetUserTouched,
      viewer: !!getViewer(),
      scene: !!getScene(getViewer())
    };
  };
  window.AS51ReplayLackset = function () {
    return finishRestoredPaint(true);
  };
  window.AS51WunschfarbeColor = function () {
    if (state.hex && parseHex(state.hex)) return parseHex(state.hex);
    try {
      return parseHex(new URLSearchParams(window.location.search).get(PARAM));
    } catch (e) {
      return '';
    }
  };

  if (attach()) {
    if (getScene(getViewer())) scheduleLacksetReplay();
    return;
  }
  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    if (attach()) {
      if (getScene(getViewer())) scheduleLacksetReplay();
      clearInterval(timer);
    } else if (tries >= 50) clearInterval(timer);
  }, 300);
})();

/**
 * REEL overlay. Injects a dock on the Angle viewer chrome and a body dialog.
 * Payment, SMTP and rendering live on the video service — not here.
 */
(function () {
  if (window.AS51ProductHandle && window.AS51ProductHandle !== '3d-konfigurator') return;
  if (window.AS51ReelInit) return;
  window.AS51ReelInit = true;

  var FALLBACK_SCENES = [
    {
      id: 'simson-meet',
      title: 'Tuning-Treff',
      description: 'Helles Tageslicht, deine S51 im Kreis der anderen.'
    },
    {
      id: 'uckermark-dusk',
      title: 'Uckermark',
      description: 'Dämmerung über der Uckermark, weiches Abendlicht.'
    },
    {
      id: 'petrol-station',
      title: 'DDR-Tankstelle',
      description: 'Nacht an einer alten Tankstelle, Licht von oben.'
    }
  ];
  var POLL_MS = 1000;
  var RENDER_SECS = 25;
  var VIDEO_FILENAME = 'meine-s51.mp4';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var state = {
    booted: false,
    open: false,
    view: 'pick',
    email: '',
    newsletter: false,
    scene: 'uckermark-dusk',
    scenes: FALLBACK_SCENES.slice(),
    jobId: '',
    status: '',
    progress: 0,
    videoUrl: '',
    videoFile: null,
    fileLoading: false,
    fileLoadId: 0,
    error: '',
    errorRaw: '',
    mockTicks: 0,
    pollTimer: 0,
    lastFocus: null,
    startedAt: 0,
    pendingComplete: null,
    queuePosition: 0
  };

  function cfg() {
    var c = window.AS51Reel || {};
    return {
      enabled: !!c.enabled,
      apiUrl: String(c.apiUrl || '').replace(/\/+$/, ''),
      exampleMp4: String(c.exampleMp4 || ''),
      examplePoster: String(c.examplePoster || ''),
      scenes: c.scenes && typeof c.scenes === 'object' ? c.scenes : {},
      waUrl: c.waUrl || 'https://wa.me/4915112725125',
      waLabel: c.waLabel || '01511 2725125'
    };
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function isValidEmail(value) {
    return EMAIL_RE.test(String(value || '').trim());
  }

  function isPhoneUi() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function videoFileFromBlob(blob) {
    var type = blob && blob.type && String(blob.type).indexOf('video/') === 0 ? blob.type : 'video/mp4';
    return new File([blob], 'meine-s51.mp4', { type: type });
  }

  function canShareVideoFile(file) {
    if (!file || !navigator.share || !navigator.canShare) return false;
    try {
      return !!navigator.canShare({ files: [file] });
    } catch (e) {
      return false;
    }
  }

  function triggerSave(file) {
    if (!file) return;
    var url = URL.createObjectURL(file);
    var a = document.createElement('a');
    a.href = url;
    a.download = VIDEO_FILENAME;
    a.rel = 'noopener';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    window.setTimeout(function () {
      if (a.parentNode) a.parentNode.removeChild(a);
      URL.revokeObjectURL(url);
    }, 2000);
  }

  function triggerSaveFromUrl(url) {
    if (!url) return;
    var a = document.createElement('a');
    a.href = url;
    a.download = VIDEO_FILENAME;
    a.rel = 'noopener';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    window.setTimeout(function () {
      if (a.parentNode) a.parentNode.removeChild(a);
    }, 0);
  }

  function resetPreparedVideo() {
    state.fileLoadId += 1;
    state.videoFile = null;
    state.fileLoading = false;
  }

  function prepareCompletedVideo(url) {
    if (!url) {
      state.fileLoading = false;
      state.videoFile = null;
      syncDoneUi();
      return;
    }
    var loadId = (state.fileLoadId += 1);
    state.fileLoading = true;
    state.videoFile = null;
    syncDoneUi();
    fetch(url, { mode: 'cors', credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('video fetch failed');
        return res.blob();
      })
      .then(function (blob) {
        if (loadId !== state.fileLoadId || !state.open) return;
        var file = videoFileFromBlob(blob);
        state.videoFile = file;
        state.fileLoading = false;
        triggerSave(file);
        syncDoneUi();
      })
      .catch(function () {
        if (loadId !== state.fileLoadId) return;
        state.fileLoading = false;
        triggerSaveFromUrl(url);
        syncDoneUi();
      });
  }

  function rawQueryValue(href, name) {
    var match = String(href || '').match(new RegExp('[?&]' + name + '=([^&#]*)'));
    return match ? match[1] : '';
  }

  function configuratorUrl() {
    var href = String(window.location.href).split('#')[0];
    var tdaState = rawQueryValue(href, 'tdaState') || rawQueryValue(href, 'as51State');
    var tdaId = rawQueryValue(href, 'tdaId');
    if (!tdaState || !tdaId) return href;
    var hex = '';
    try {
      if (typeof window.AS51WunschfarbeColor === 'function') hex = window.AS51WunschfarbeColor() || '';
    } catch (e) {
      hex = '';
    }
    if (!hex) {
      try {
        hex = decodeURIComponent(rawQueryValue(href, 'wunschfarbe') || '')
          .replace('#', '')
          .toUpperCase();
      } catch (e2) {
        hex = '';
      }
    }
    if (!/^[0-9A-F]{6}$/.test(hex)) return href;
    if (/[?&]wunschfarbe=/.test(href)) {
      return href.replace(/([?&]wunschfarbe=)[^&]*/, '$1' + hex);
    }
    return href + '&wunschfarbe=' + hex;
  }

  function hasSavedConfiguration() {
    var href = window.location.href;
    return !!(rawQueryValue(href, 'tdaState') || rawQueryValue(href, 'as51State')) && !!rawQueryValue(href, 'tdaId');
  }

  function sanitizeWanPrompts(data) {
    var list = [];
    if (data && Array.isArray(data.options)) list = data.options;
    else if (Array.isArray(data)) list = data;
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var item = list[i] || {};
      var id = String(item.id || '').trim();
      if (!id) continue;
      out.push({
        id: id,
        title: String(item.title || id),
        description: String(item.description || '')
      });
    }
    return out;
  }

  function buildFreePayload(url, email, newsletter) {
    return {
      type: 'free',
      template: 'studio-01',
      configuratorUrl: String(url || ''),
      email: String(email || '').trim(),
      newsletter: !!newsletter
    };
  }

  function buildCinematicCheckoutPayload(url, scene, email, newsletter) {
    return {
      email: String(email || '').trim(),
      scene: String(scene || ''),
      configuratorUrl: String(url || ''),
      newsletter: !!newsletter
    };
  }

  function statusLabel(status) {
    if (status === 'queued') return 'Eingereiht';
    if (status === 'rendering') return 'Rendert';
    if (status === 'processing') return 'Wird verarbeitet';
    if (status === 'completed') return 'Fertig';
    if (status === 'failed') return 'Fehler';
    return 'Unterwegs';
  }

  function cinematicStubMessage() {
    return 'Zahlung folgt — noch nicht live';
  }

  function waText(error, rawError) {
    var message = 'Hallo Area S51, mein Reel aus dem Konfigurator hat nicht geklappt.';
    var detail = String(rawError || error || '')
      .replace(/\r\n/g, '\n')
      .trim();
    if (!detail) return message;
    if (detail.length > 400) detail = detail.slice(0, 397) + '...';
    return message + '\n\nFehler: ' + detail;
  }

  function waHref() {
    var base = cfg().waUrl;
    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'text=' + encodeURIComponent(waText(state.error, state.errorRaw));
  }

  function mockStatus(id, ticks) {
    if (ticks >= RENDER_SECS) {
      return {
        id: id,
        status: 'completed',
        progress: 100,
        videoUrl: cfg().exampleMp4 || null
      };
    }
    var pct = Math.max(4, Math.round((ticks / RENDER_SECS) * 99));
    var status = ticks < 4 ? 'queued' : ticks < 18 ? 'rendering' : 'processing';
    return { id: id, status: status, progress: pct, videoUrl: null };
  }

  function jobsAhead() {
    var n = Number(state.queuePosition);
    return Number.isFinite(n) && n > 0 ? Math.round(n) : 0;
  }

  function waitingInQueue() {
    return state.status === 'queued' && jobsAhead() > 0;
  }

  function remainingSecs() {
    var ahead = jobsAhead();
    if (waitingInQueue()) return ahead * RENDER_SECS + RENDER_SECS;
    if (state.progress > 0 && state.progress < 100) {
      return Math.max(0, Math.ceil(((100 - state.progress) / 100) * RENDER_SECS));
    }
    if (!state.startedAt) return RENDER_SECS;
    return Math.max(0, Math.ceil(RENDER_SECS - (Date.now() - state.startedAt) / 1000));
  }

  function etaCopy(left) {
    if (left >= 60) {
      var min = Math.ceil(left / 60);
      return min === 1 ? 'Noch etwa 1 Min' : 'Noch etwa ' + min + ' Min';
    }
    if (left > 0) return 'Noch etwa ' + left + ' Sek';
    return 'dauert noch einen Moment';
  }

  function parseVideoStatus(data, id) {
    var row = data || {};
    var ahead = row.queuePosition;
    return {
      id: String(row.id || id || ''),
      status: String(row.status || ''),
      progress: Math.max(0, Math.min(100, Number(row.progress) || 0)),
      videoUrl: row.videoUrl || null,
      error: row.error ? String(row.error) : '',
      queuePosition: Number.isFinite(Number(ahead)) ? Math.max(0, Math.round(Number(ahead))) : 0
    };
  }

  function humanRenderError(raw) {
    var text = String(raw || '');
    if (/Executable doesn't exist|Playwright|chrome-headless-shell/i.test(text)) {
      return 'Der Video-Renderer auf der Box konnte Chromium nicht starten. Bitte Seite neu laden und nochmal versuchen.';
    }
    if (text && text.length < 180 && text.indexOf('\n') < 0) return text;
    return 'Das Reel konnte nicht erzeugt werden. Schreib uns auf WhatsApp: ' + cfg().waLabel + '.';
  }

  function apiRequest(path, options) {
    var base = cfg().apiUrl;
    if (!base) return mockRequest(path, options);
    var opts = options || {};
    var init = {
      method: opts.method || 'GET',
      headers: { Accept: 'application/json' }
    };
    if (opts.body) {
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(opts.body);
    }
    return fetch(base + path, init).then(function (res) {
      return res
        .json()
        .catch(function () {
          return {};
        })
        .then(function (body) {
          return { ok: res.ok, status: res.status, body: body };
        });
    });
  }

  function mockRequest(path, options) {
    var opts = options || {};
    var method = opts.method || 'GET';
    if (path === '/v1/wan-prompts' && method === 'GET') {
      return Promise.resolve({
        ok: true,
        status: 200,
        body: { options: FALLBACK_SCENES.slice() }
      });
    }
    if (path === '/v1/checkouts' && method === 'POST') {
      return Promise.resolve({
        ok: false,
        status: 501,
        body: { error: cinematicStubMessage() }
      });
    }
    if (path === '/v1/videos' && method === 'POST') {
      if (opts.body && opts.body.type === 'cinematic') {
        return Promise.resolve({
          ok: false,
          status: 501,
          body: { error: cinematicStubMessage() }
        });
      }
      state.mockTicks = 0;
      return Promise.resolve({
        ok: true,
        status: 202,
        body: { id: 'mock-' + Date.now(), status: 'queued' }
      });
    }
    if (method === 'GET' && path.indexOf('/v1/videos/') === 0) {
      state.mockTicks += 1;
      var id = path.slice('/v1/videos/'.length);
      return Promise.resolve({
        ok: true,
        status: 200,
        body: mockStatus(id, state.mockTicks)
      });
    }
    return Promise.resolve({ ok: false, status: 404, body: {} });
  }

  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }

  function setView(name) {
    state.view = name;
    if (!state.overlay) return;
    var views = state.overlay.querySelectorAll('[data-wh-reel-view]');
    for (var i = 0; i < views.length; i++) {
      views[i].hidden = views[i].getAttribute('data-wh-reel-view') !== name;
    }
    var kicker = qs(state.overlay, '[data-wh-reel-kicker]');
    var title = qs(state.overlay, '[data-wh-reel-title]');
    var back = qs(state.overlay, '[data-wh-reel-back]');
    var price = qs(state.overlay, '[data-wh-reel-price]');
    var emailWrap = qs(state.overlay, '[data-wh-reel-emailwrap]');
    if (kicker) {
      kicker.textContent =
        name === 'pick'
          ? 'Aus deiner Konfiguration'
          : name === 'scenes' || name === 'stub'
            ? 'Cinematic-Video'
            : name === 'progress' || name === 'done' || name === 'email'
              ? 'Speed-Ramp-Clip · Gratis'
              : name === 'error'
                ? 'Reel'
                : '';
    }
    if (title) {
      title.textContent =
        name === 'pick'
          ? 'Deine S51 als Video.'
          : name === 'scenes'
            ? 'Deine Szene'
            : name === 'progress'
              ? waitingInQueue()
                ? 'Du bist in der Schlange.'
                : 'Dein Clip wird gebaut.'
              : name === 'done'
                ? 'Dein Reel ist fertig.'
              : name === 'error'
                ? 'Das hat nicht geklappt.'
                : name === 'stub'
                  ? 'Zahlung folgt'
                  : 'Deine S51 als Video.';
    }
    var headText = qs(state.overlay, '[data-wh-reel-headtext]');
    if (headText) headText.hidden = false;
    if (back) back.hidden = name === 'pick' || name === 'progress' || name === 'done';
    if (price) price.hidden = true;
    if (emailWrap) emailWrap.hidden = name !== 'progress' && name !== 'done';
    var note = qs(state.overlay, '[data-wh-reel-note]');
    if (note) note.hidden = name !== 'pick' && name !== 'progress' && name !== 'done';
    var caption = qs(state.overlay, '[data-wh-reel-caption]');
    if (caption) {
      caption.textContent =
        name === 'done'
          ? 'Dein Clip'
          : name === 'progress'
            ? 'Wird gebaut'
            : name === 'error'
              ? 'Fehler'
              : 'Beispiel · Studio';
    }
    state.overlay.classList.toggle('is-done', name === 'done' && !!state.videoUrl);
    syncEmailUi();
    syncProgressUi();
    syncDoneUi();
    syncErrorUi();
    syncStubUi();
    syncMedia();
  }

  function syncEmailUi() {
    if (!state.overlay) return;
    var email = qs(state.overlay, '[data-wh-reel-email]');
    var news = qs(state.overlay, '[data-wh-reel-news]');
    var valid = isValidEmail(state.email);
    if (email && email.value !== state.email) email.value = state.email;
    if (news) news.checked = !!state.newsletter;
    var freeBtn = qs(state.overlay, '[data-wh-reel-free]');
    var startBtn = qs(state.overlay, '[data-wh-reel-start]');
    var sceneCta = qs(state.overlay, '[data-wh-reel-cinematic]');
    var payBtn = qs(state.overlay, '[data-wh-reel-pay]');
    if (freeBtn) freeBtn.disabled = false;
    if (startBtn) startBtn.disabled = false;
    if (sceneCta) sceneCta.disabled = true;
    if (payBtn) payBtn.disabled = true;
    var hint = qs(state.overlay, '[data-wh-reel-emailneed]');
    if (hint) hint.hidden = valid;
  }

  function syncProgressUi() {
    if (!state.overlay) return;
    var waiting = waitingInQueue();
    var ahead = jobsAhead();
    var num = qs(state.overlay, '[data-wh-reel-pct]');
    var unit = qs(state.overlay, '[data-wh-reel-unit]');
    var kicker = qs(state.overlay, '[data-wh-reel-progress-kicker]');
    var label = qs(state.overlay, '[data-wh-reel-status]');
    var bar = qs(state.overlay, '[data-wh-reel-bar]');
    if (kicker) kicker.textContent = waiting ? 'Dein Platz' : 'Fortschritt';
    if (num) num.textContent = waiting ? String(ahead + 1) : String(Math.round(state.progress || 0));
    if (unit) unit.textContent = waiting ? '' : '%';
    if (label) {
      label.textContent = waiting
        ? ahead === 1
          ? '1 Clip vor dir'
          : ahead + ' Clips vor dir'
        : statusLabel(state.status);
    }
    if (bar) bar.style.width = waiting ? '0%' : Math.round(state.progress || 0) + '%';
    var eta = qs(state.overlay, '[data-wh-reel-eta]');
    if (eta) eta.textContent = etaCopy(remainingSecs());
  }

  function syncDoneUi() {
    if (!state.overlay) return;
    var phone = isPhoneUi();
    var url = state.videoUrl || '';
    var file = state.videoFile;
    var ready = !!file || !!url;
    var actions = qs(state.overlay, '[data-wh-reel-actions]');
    var dl = qs(state.overlay, '[data-wh-reel-download]');
    var share = qs(state.overlay, '[data-wh-reel-share]');
    var copy = qs(state.overlay, '[data-wh-reel-copy]');
    var hint = qs(state.overlay, '[data-wh-reel-sharehint]');
    var nofile = qs(state.overlay, '[data-wh-reel-nofile]');
    if (actions) actions.classList.toggle('wh-reel-actions--phone', phone);
    if (dl) {
      if (url) {
        dl.setAttribute('href', url);
        dl.setAttribute('download', VIDEO_FILENAME);
      } else {
        dl.removeAttribute('href');
        dl.removeAttribute('download');
      }
      dl.toggleAttribute('aria-disabled', !url);
      dl.hidden = phone && !!file;
    }
    if (copy) {
      copy.disabled = !url;
      copy.hidden = phone;
    }
    if (share) {
      var fileShare = !!(file && canShareVideoFile(file));
      share.hidden = phone ? false : !fileShare;
      share.disabled = phone ? !ready || (!file && state.fileLoading) : !fileShare;
      share.textContent = phone && state.fileLoading && !file ? 'Wird geladen…' : 'Teilen';
      share.classList.toggle('wh-reel-cta--yellow', phone);
    }
    if (hint) hint.hidden = !phone || !url;
    if (nofile) nofile.hidden = !!url;
    state.overlay.classList.toggle('is-done', state.view === 'done' && !!url);
  }

  function syncErrorUi() {
    if (!state.overlay) return;
    var p = qs(state.overlay, '[data-wh-reel-error]');
    if (p) {
      p.textContent =
        state.error ||
        'Das Reel konnte nicht erzeugt werden. Der 3D-Konfigurator läuft weiter.';
    }
    var a = qs(state.overlay, '[data-wh-reel-wa]');
    if (a) {
      a.href = waHref();
      a.textContent = 'WhatsApp ' + cfg().waLabel;
    }
  }

  function syncStubUi() {
    if (!state.overlay) return;
    var p = qs(state.overlay, '[data-wh-reel-stub]');
    if (p) p.textContent = cinematicStubMessage();
  }

  function scenePoster(id) {
    var map = cfg().scenes || {};
    return map[id] || '';
  }

  function syncMedia() {
    if (!state.overlay) return;
    var example = qs(state.overlay, '[data-wh-reel-example]');
    var result = qs(state.overlay, '[data-wh-reel-result]');
    var fallback = qs(state.overlay, '[data-wh-reel-fallback]');
    var poster = qs(state.overlay, '[data-wh-reel-poster]');
    var exampleSrc = cfg().exampleMp4;
    var posterSrc = cfg().examplePoster;
    if (state.view === 'done' && state.videoUrl) {
      if (example) {
        example.hidden = true;
        example.pause();
      }
      if (fallback) fallback.hidden = true;
      if (poster) poster.hidden = true;
      if (result) {
        result.hidden = false;
        result.muted = true;
        result.playsInline = true;
        result.setAttribute('muted', '');
        result.setAttribute('autoplay', '');
        result.setAttribute('playsinline', '');
        if (result.getAttribute('src') !== state.videoUrl) {
          result.src = state.videoUrl;
        }
        var play = result.play();
        if (play && play.catch) play.catch(function () {});
      }
      return;
    }
    if (result) {
      result.hidden = true;
      result.pause();
    }
    if (exampleSrc) {
      if (example) {
        example.hidden = false;
        if (example.getAttribute('src') !== exampleSrc) example.src = exampleSrc;
      }
      if (poster) poster.hidden = true;
      if (fallback) fallback.hidden = true;
      return;
    }
    if (example) example.hidden = true;
    if (posterSrc && poster) {
      if (poster.getAttribute('src') !== posterSrc) poster.src = posterSrc;
      poster.hidden = false;
      if (fallback) fallback.hidden = true;
    } else {
      if (poster) poster.hidden = true;
      if (fallback) fallback.hidden = false;
    }
  }

  function fillCardThumbs() {
    if (!state.overlay) return;
    var thumbs = state.overlay.querySelectorAll('[data-wh-reel-thumb]');
    for (var i = 0; i < thumbs.length; i++) {
      var key = thumbs[i].getAttribute('data-wh-reel-thumb');
      var src = key === 'studio' ? cfg().examplePoster : scenePoster(key);
      if (!src || thumbs[i].querySelector('img')) continue;
      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      thumbs[i].appendChild(img);
    }
  }

  function renderScenes() {
    var host = state.overlay && qs(state.overlay, '[data-wh-reel-scenes]');
    if (!host) return;
    host.textContent = '';
    var list = state.scenes.length ? state.scenes : FALLBACK_SCENES;
    for (var i = 0; i < list.length; i++) {
      var item = list[i];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wh-reel-scene' + (item.id === state.scene ? ' is-selected' : '');
      btn.setAttribute('data-id', item.id);
      btn.setAttribute('aria-pressed', item.id === state.scene ? 'true' : 'false');
      var thumb = document.createElement('div');
      thumb.className = 'wh-reel-scene__thumb';
      var src = scenePoster(item.id);
      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        thumb.appendChild(img);
      }
      var tag = document.createElement('span');
      tag.textContent =
        item.id === 'simson-meet'
          ? 'Tag'
          : item.id === 'uckermark-dusk'
            ? 'Dämmerung'
            : item.id === 'petrol-station'
              ? 'Nacht'
              : item.title;
      thumb.appendChild(tag);
      var name = document.createElement('div');
      name.className = 'wh-reel-scene__title';
      name.textContent = item.title;
      var desc = document.createElement('div');
      desc.className = 'wh-reel-scene__desc';
      desc.textContent = item.description;
      btn.appendChild(thumb);
      btn.appendChild(name);
      btn.appendChild(desc);
      host.appendChild(btn);
    }
  }

  function stopPoll() {
    if (state.pollTimer) window.clearTimeout(state.pollTimer);
    state.pollTimer = 0;
  }

  function fail(message, raw) {
    stopPoll();
    state.error = message;
    state.errorRaw = raw != null && String(raw).trim() ? String(raw) : '';
    setView('error');
  }

  function applyJob(row) {
    state.jobId = row.id || state.jobId;
    if (row.status === 'failed') {
      fail(humanRenderError(row.error), row.error);
      return;
    }
    if (row.status === 'completed') {
      var url = row.videoUrl || '';
      var already = state.status === 'completed' && state.videoUrl === url;
      state.status = 'completed';
      state.progress = 100;
      state.queuePosition = 0;
      state.videoUrl = url;
      stopPoll();
      setView('done');
      if (!already) prepareCompletedVideo(url);
      return;
    }
    state.status = row.status;
    state.progress = row.progress;
    state.videoUrl = row.videoUrl || '';
    if (row.queuePosition !== undefined) state.queuePosition = row.queuePosition;
    if (state.overlay) {
      var title = qs(state.overlay, '[data-wh-reel-title]');
      if (title && state.view === 'progress') {
        title.textContent = waitingInQueue() ? 'Du bist in der Schlange.' : 'Dein Clip wird gebaut.';
      }
    }
    syncProgressUi();
  }

  function pollJob() {
    if (!state.jobId) return;
    apiRequest('/v1/videos/' + encodeURIComponent(state.jobId))
      .then(function (res) {
        if (!state.open) return;
        if (!res.ok) {
          fail('Der Status des Reels war nicht erreichbar. Der Konfigurator bleibt nutzbar.');
          return;
        }
        applyJob(parseVideoStatus(res.body, state.jobId));
        if (state.view === 'progress') {
          state.pollTimer = window.setTimeout(pollJob, POLL_MS);
        }
      })
      .catch(function () {
        if (!state.open) return;
        fail('Die Video-API ist nicht erreichbar. Deine S51 im Viewer bleibt unberührt.');
      });
  }

  function startFree() {
    if (!hasSavedConfiguration()) {
      fail(
        'Die Konfiguration steckt noch nicht im Link. Ändere eine Option am Moped, bis die Adresse tdaState enthält, und versuch es nochmal.'
      );
      return;
    }
    state.jobType = 'free';
    state.startedAt = Date.now();
    state.pendingComplete = null;
    state.progress = 0;
    state.status = 'queued';
    state.queuePosition = 0;
    state.videoUrl = '';
    state.jobId = '';
    resetPreparedVideo();
    setView('progress');
    apiRequest('/v1/videos', {
      method: 'POST',
      body: buildFreePayload(configuratorUrl(), state.email, state.newsletter)
    })
      .then(function (res) {
        if (!state.open) return;
        if (res.status === 501) {
          fail(cinematicStubMessage());
          return;
        }
        if (!res.ok || !res.body || !res.body.id) {
          fail(
            (res.body && res.body.error) ||
              'Das kostenlose Video konnte nicht gestartet werden. Schreib uns auf WhatsApp.',
            res.body && res.body.error
          );
          return;
        }
        applyJob(parseVideoStatus(res.body, res.body.id));
        state.pollTimer = window.setTimeout(pollJob, POLL_MS);
      })
      .catch(function () {
        if (!state.open) return;
        fail('Die Video-API ist nicht erreichbar. Der 3D-Konfigurator läuft weiter.');
      });
  }

  function loadScenes() {
    return apiRequest('/v1/wan-prompts')
      .then(function (res) {
        var list = sanitizeWanPrompts(res && res.body);
        state.scenes = list.length ? list : FALLBACK_SCENES.slice();
        if (!state.scene || !state.scenes.some(function (s) { return s.id === state.scene; })) {
          state.scene = state.scenes[0] ? state.scenes[0].id : 'uckermark-dusk';
        }
        renderScenes();
      })
      .catch(function () {
        state.scenes = FALLBACK_SCENES.slice();
        renderScenes();
      });
  }

  /**
   * Isolated cinematic checkout via the video API (draft-order invoice URL).
   * Theme never touches /cart/add.js or Stripe. 501 → stub copy.
   */
  function startCinematicCheckout(args) {
    var opts = args || {};
    var payload = buildCinematicCheckoutPayload(
      opts.configuratorUrl || configuratorUrl(),
      opts.scene || state.scene,
      opts.email || state.email,
      state.newsletter
    );
    if (!isValidEmail(payload.email) || !payload.scene) {
      setView('stub');
      return;
    }
    apiRequest('/v1/checkouts', { method: 'POST', body: payload })
      .then(function (res) {
        if (!state.open) return;
        var invoice = res && res.body && res.body.invoiceUrl;
        if (res && res.ok && invoice) {
          window.open(invoice, '_blank', 'noopener');
        }
        setView('stub');
      })
      .catch(function () {
        if (!state.open) return;
        setView('stub');
      });
  }

  function openScenes() {
    if (!isValidEmail(state.email)) {
      syncEmailUi();
      return;
    }
    setView('scenes');
    loadScenes();
  }

  function closeOverlay() {
    stopPoll();
    state.open = false;
    if (state.overlay) state.overlay.hidden = true;
    document.body.classList.remove('wh-reel-open');
    var example = state.overlay && qs(state.overlay, '[data-wh-reel-example]');
    var result = state.overlay && qs(state.overlay, '[data-wh-reel-result]');
    if (example) example.pause();
    if (result) result.pause();
    if (state.lastFocus && state.lastFocus.focus) {
      try {
        state.lastFocus.focus();
      } catch (e) {
        /* ignore */
      }
    }
  }

  function openOverlay() {
    // Overlay erst beim ersten Öffnen bauen (Lighthouse: keine Reel-Bilder
    // und keine <a> ohne href beim Seitenladen).
    if (!state.overlay) {
      state.overlay = buildOverlay();
      var dockBtn = state.dock && qs(state.dock, '.wh-reel-btn');
      if (dockBtn) dockBtn.setAttribute('aria-controls', 'wh-reel-overlay');
    }
    state.lastFocus = document.activeElement;
    state.open = true;
    state.view = 'pick';
    state.error = '';
    state.overlay.hidden = false;
    document.body.classList.add('wh-reel-open');
    setView('pick');
    renderScenes();
    var closeBtn = qs(state.overlay, '[data-wh-reel-close="btn"]');
    if (closeBtn) closeBtn.focus();
    var example = qs(state.overlay, '[data-wh-reel-example]');
    if (example && cfg().exampleMp4) {
      var play = example.play();
      if (play && play.catch) play.catch(function () {});
    }
  }

  function copyLink() {
    var url = state.videoUrl;
    if (!url) return;
    var done = function () {
      var copy = qs(state.overlay, '[data-wh-reel-copy]');
      if (copy) copy.textContent = 'Link kopiert';
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(function () {
        window.prompt('Link kopieren:', url);
      });
      return;
    }
    window.prompt('Link kopieren:', url);
  }

  function shareVideo() {
    var file = state.videoFile;
    var url = state.videoUrl;
    if (file && canShareVideoFile(file)) {
      navigator
        .share({
          title: 'Meine S51 — Area S51',
          files: [file]
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          triggerSave(file);
        });
      return;
    }
    if (file) {
      triggerSave(file);
      return;
    }
    if (url) triggerSaveFromUrl(url);
  }

  function onOverlayClick(ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-wh-reel-close]')) {
      closeOverlay();
      return;
    }
    if (t.closest('[data-wh-reel-back]')) {
      setView('pick');
      return;
    }
    if (t.closest('[data-wh-reel-free]')) {
      startFree();
      return;
    }
    if (t.closest('[data-wh-reel-send]')) {
      copyLink();
      return;
    }
    if (t.closest('[data-wh-reel-cinematic]') || t.closest('[data-wh-reel-pay]')) {
      return;
    }
    var sceneBtn = t.closest('[data-wh-reel-scenes] [data-id]');
    if (sceneBtn) {
      state.scene = sceneBtn.getAttribute('data-id');
      renderScenes();
      return;
    }
    if (t.closest('[data-wh-reel-share]') || t.closest('[data-wh-reel-sharehint]')) {
      shareVideo();
      return;
    }
    if (t.closest('[data-wh-reel-copy]')) {
      copyLink();
    }
  }

  function onOverlayInput(ev) {
    var t = ev.target;
    if (!t) return;
    if (t.getAttribute('data-wh-reel-email') !== null) {
      state.email = t.value;
      syncEmailUi();
    }
    if (t.getAttribute('data-wh-reel-news') !== null) {
      state.newsletter = !!t.checked;
    }
  }

  function buildOverlay() {
    var root = document.createElement('div');
    root.id = 'wh-reel-overlay';
    root.className = 'wh-reel-overlay';
    root.hidden = true;
    root.innerHTML =
      '<button type="button" class="wh-reel-overlay__scrim" data-wh-reel-close aria-label="Schließen"></button>' +
      '<div class="wh-reel-dialog" role="dialog" aria-modal="true" aria-labelledby="wh-reel-title">' +
      '<div class="wh-reel-dialog__media">' +
      '<div class="wh-reel-dialog__handle" aria-hidden="true"></div>' +
      '<div class="wh-reel-stage">' +
      '<img class="wh-reel-stage__img" data-wh-reel-poster alt="" hidden>' +
      '<video data-wh-reel-example playsinline muted loop preload="metadata" hidden></video>' +
      '<video data-wh-reel-result playsinline controls preload="metadata" hidden></video>' +
      '<div class="wh-reel-fallback" data-wh-reel-fallback>' +
      '<span class="wh-reel-fallback__play" aria-hidden="true"></span>' +
      '<span class="wh-reel-fallback__kicker">Beispiel</span>' +
      '<strong class="wh-reel-fallback__title">11 Sekunden</strong>' +
      '</div>' +
      '<p class="wh-reel-stage__label" data-wh-reel-caption>Beispiel · Studio</p>' +
      '</div></div>' +
      '<div class="wh-reel-dialog__main">' +
      '<div class="wh-reel-head">' +
      '<button type="button" class="wh-reel-iconbtn" data-wh-reel-back hidden aria-label="Zurück">‹</button>' +
      '<div class="wh-reel-head__text" data-wh-reel-headtext>' +
      '<p class="wh-reel-kicker" data-wh-reel-kicker>Aus deiner Konfiguration</p>' +
      '<h2 class="wh-reel-title" id="wh-reel-title" data-wh-reel-title>Deine S51 als Video.</h2>' +
      '</div>' +
      '<div class="wh-reel-price" data-wh-reel-price hidden>4,99 €</div>' +
      '<button type="button" class="wh-reel-iconbtn" data-wh-reel-close="btn" aria-label="Schließen">✕</button>' +
      '</div>' +
      '<div class="wh-reel-view" data-wh-reel-view="pick">' +
      '<button type="button" class="wh-reel-card is-selected" data-wh-reel-free>' +
      '<div class="wh-reel-card__thumb" data-wh-reel-thumb="studio"></div>' +
      '<div class="wh-reel-card__body">' +
      '<div class="wh-reel-card__row"><span class="wh-reel-card__title">Speed-Ramp-Clip</span>' +
      '<span class="wh-reel-badge">Gratis</span></div>' +
      '<p class="wh-reel-card__text">Deine S51 als Speed-Ramp-Clip: langsam rein, schneller Schwenk, sauberer Stopp.</p>' +
      '<p class="wh-reel-meta">11 Sek · HD · Hochformat</p>' +
      '<span class="wh-reel-cta">Jetzt erstellen</span>' +
      '</div></button>' +
      '<div class="wh-reel-card wh-reel-card--soon">' +
      '<div class="wh-reel-card__thumb" data-wh-reel-thumb="uckermark-dusk"></div>' +
      '<div class="wh-reel-card__body">' +
      '<div class="wh-reel-card__row"><span class="wh-reel-card__title">Zum Leben erweckt</span>' +
      '<span class="wh-reel-badge wh-reel-badge--ink">4,99 €</span>' +
      '<span class="wh-reel-badge">Bald</span></div>' +
      '<p class="wh-reel-card__text">KI setzt deine S51 in eine echte Szene — du wählst eine von drei Szenen.</p>' +
      '<p class="wh-reel-meta">11 Sek · HD · Download + Mail · bezahlt wird nach der Szenenwahl</p>' +
      '<span class="wh-reel-cta wh-reel-cta--ink wh-reel-cta--soon">Bald verfügbar</span>' +
      '</div></div>' +
      '</div>' +
      '<div class="wh-reel-view" data-wh-reel-view="scenes" hidden>' +
      '<div class="wh-reel-scenes" data-wh-reel-scenes></div>' +
      '<div class="wh-reel-foot">' +
      '<button type="button" class="wh-reel-cta wh-reel-cta--yellow wh-reel-cta--soon" data-wh-reel-pay disabled>Bald verfügbar</button>' +
      '</div></div>' +
      '<div class="wh-reel-view" data-wh-reel-view="progress" hidden>' +
      '<div class="wh-reel-progress">' +
      '<div><div class="wh-reel-kicker" data-wh-reel-progress-kicker>Dein Platz</div>' +
      '<div class="wh-reel-progress__num"><span data-wh-reel-pct>1</span><span data-wh-reel-unit></span></div></div>' +
      '<div class="wh-reel-bar" aria-hidden="true"><span data-wh-reel-bar></span></div>' +
      '<p class="wh-reel-meta" data-wh-reel-status>Eingereiht</p>' +
      '<p class="wh-reel-meta" data-wh-reel-eta>Noch etwa 25 Sek</p>' +
      '<p class="wh-reel-meta">Der Download startet automatisch, sobald dein Clip fertig ist. Lass den Tab offen — oder hol dir den Link per Mail.</p>' +
      '</div>' +
      '<div class="wh-reel-field" data-wh-reel-emailwrap>' +
      '<div class="wh-reel-field__labelrow"><span class="wh-reel-field__label">Deine E-Mail</span>' +
      '<span class="wh-reel-field__hint">für den Download-Link</span></div>' +
      '<div class="wh-reel-sendrow">' +
      '<input class="wh-reel-input" data-wh-reel-email type="email" autocomplete="email" inputmode="email" placeholder="deine@mail.de">' +
      '<button type="button" class="wh-reel-cta wh-reel-cta--yellow" data-wh-reel-send>Link senden</button>' +
      '</div>' +
      '<p class="wh-reel-meta">Falls die Verbindung abbricht, liegt der Link trotzdem in deinem Postfach. Kein Newsletter.</p>' +
      '</div></div>' +
      '<div class="wh-reel-view" data-wh-reel-view="done" hidden>' +
      '<p class="wh-reel-meta" data-wh-reel-nofile hidden>Kein Beispiel-Clip hinterlegt. Download folgt, sobald die Datei da ist.</p>' +
      '<p class="wh-reel-meta" data-wh-reel-sharehint hidden>Tippe Teilen — Instagram, TikTok oder in die Galerie.</p>' +
      '<div class="wh-reel-actions" data-wh-reel-actions>' +
      '<a class="wh-reel-cta wh-reel-cta--yellow" data-wh-reel-download download="meine-s51.mp4">Download</a>' +
      '<button type="button" class="wh-reel-cta" data-wh-reel-share>Teilen</button>' +
      '<button type="button" class="wh-reel-cta" data-wh-reel-copy>Link kopieren</button>' +
      '</div></div>' +
      '<div class="wh-reel-view" data-wh-reel-view="error" hidden>' +
      '<div class="wh-reel-error">' +
      '<p data-wh-reel-error></p>' +
      '<a class="wh-reel-cta wh-reel-cta--yellow" data-wh-reel-wa target="_blank" rel="noopener">WhatsApp</a>' +
      '</div></div>' +
      '<div class="wh-reel-view" data-wh-reel-view="stub" hidden>' +
      '<p data-wh-reel-stub></p>' +
      '<p class="wh-reel-meta">Cinematic-Video wird später über einen eigenen Warenkorb bezahlt, nicht über die S51 im Konfigurator.</p>' +
      '</div>' +
      '<div class="wh-reel-note" data-wh-reel-note>Poste dein Video auf TikTok oder Instagram mit <span class="wh-reel-mark">#meineS51</span> — wir teilen die besten Builds.</div>' +
      '</div></div>';
    root.addEventListener('click', onOverlayClick);
    root.addEventListener('input', onOverlayInput);
    root.addEventListener('change', onOverlayInput);
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && state.open) closeOverlay();
    });
    document.body.appendChild(root);
    state.overlay = root;
    fillCardThumbs();
    return root;
  }

  function buildDock() {
    var dock = document.createElement('div');
    dock.className = 'wh-reel-dock';
    dock.innerHTML =
      '<button type="button" class="wh-reel-btn" aria-haspopup="dialog" aria-label="Video erstellen">' +
      '<span class="wh-reel-hint" aria-hidden="true">Video erstellen</span>' +
      '<span class="wh-reel-btn__pulse" aria-hidden="true"></span>' +
      '<span class="wh-reel-btn__icon" aria-hidden="true"></span>' +
      '</button>';
    var btn = dock.querySelector('.wh-reel-btn');
    btn.addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      openOverlay();
    });
    btn.addEventListener('pointerdown', function (ev) {
      ev.stopPropagation();
    });
    return dock;
  }

  function hostEl() {
    return (
      document.querySelector('.tda-app-section-model-viewer-sticky-container') ||
      document.querySelector('.tda-app-section-model-viewer-container')
    );
  }

  function viewerEl(host) {
    return host.querySelector('tda-model-viewer') || host.querySelector('model-viewer');
  }

  function syncDock() {
    var host = state.host;
    var viewer = host && viewerEl(host);
    var dock = state.dock;
    if (!host || !viewer || !dock) return;
    dock.style.left = viewer.offsetLeft + 'px';
    dock.style.top = viewer.offsetTop + 'px';
    dock.style.width = viewer.offsetWidth + 'px';
    dock.style.height = viewer.offsetHeight + 'px';
  }

  function placeDock() {
    var host = hostEl();
    if (!host) return false;
    if (!state.dock || !state.dock.isConnected) {
      state.dock = buildDock();
    }
    if (state.dock.parentNode !== host) host.appendChild(state.dock);
    state.host = host;
    syncDock();
    if (!state.ro && window.ResizeObserver) {
      state.ro = new ResizeObserver(syncDock);
      state.ro.observe(host);
      var viewer = viewerEl(host);
      if (viewer) state.ro.observe(viewer);
    }
    return true;
  }

  function boot() {
    if (!cfg().enabled) return false;
    if (state.booted && state.dock && state.dock.isConnected) {
      syncDock();
      return true;
    }
    if (!placeDock()) return false;
    state.booted = true;
    return true;
  }

  window.AS51ReelBoot = function () {
    var current = window.AS51Reel || {};
    current.enabled = true;
    window.AS51Reel = current;
    state.booted = false;
    boot();
  };

  window.AS51ReelApi = {
    sanitizeWanPrompts: sanitizeWanPrompts,
    buildFreePayload: buildFreePayload,
    buildCinematicCheckoutPayload: buildCinematicCheckoutPayload,
    isValidEmail: isValidEmail,
    configuratorUrl: configuratorUrl,
    cinematicStubMessage: cinematicStubMessage,
    startCinematicCheckout: startCinematicCheckout,
    statusLabel: statusLabel,
    parseVideoStatus: parseVideoStatus,
    videoFileFromBlob: videoFileFromBlob,
    canShareVideoFile: canShareVideoFile,
    FALLBACK_SCENES: FALLBACK_SCENES
  };

  window.addEventListener('Angle3DCustomizerLoaded', function () {
    boot();
  });
  if (boot()) return;
  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    if (boot() || tries >= 50) clearInterval(timer);
  }, 300);
})();
